function StandardConfigureModel () {
}

StandardConfigureModel.prototype = {

    initialize: function (productConfigData, operationGroups) {
        this.productConfigData = productConfigData;
        this.operationGroups = operationGroups;

        this.initializePrivilegedModeFlags();

        this.initializeAutoDeviceSwitch();
        this.initializeDeviceChoice();
        this.initializePressSheetsChoice();
        this.initializeCoverPressSheetsChoice();
        this.initializeSide1InksChoice();
        this.initializeSide2InksChoice();
        this.initializeCoverSide1InksChoice();
        this.initializeCoverSide2InksChoice();
        this.initializeOperations();

        this.initializeProofsChoice();
        this.initializeTurnaroundTimesChoice();
        this.initializeBleedChoice();
        this.initializeDimensionsChoice();
        this.initializePagesChoice();
        this.initializeQuantities();
        this.initializeOverrides();
        this.initializeAdditionalFields();
    },

    initializeAutoDeviceSwitch: function () {
        if (configureCommonGlobals.REQUOTE_MODE) {
            this.autoDeviceSwitch = false;
            return;
        }
        if (this.isReorder()) {
            this.autoDeviceSwitch = false;
            if (globalpageglobals.cstorefrontsettings.reorderQuoteInitialAutoDeviceSwitchModeEnabled) {
                this.autoDeviceSwitch = this.productConfigData
                    && (!this.isShowDeviceTypes() || !this.isEditDeviceType() || !this.isShowAutoDeviceOption());
            }
        } else {
            this.autoDeviceSwitch = this.productConfigData
                && (!this.isShowDeviceTypes() || !this.isEditDeviceType() || this.isShowAutoDeviceOption());
        }
    },

    initializeOverrides: function () {
        if (this.productConfigData.overrides && this.productConfigData.overrides.totalPriceOverrideAmount) {
            this.totalPriceOverrideAmount = this.productConfigData.overrides.totalPriceOverrideAmount;
        } else {
            this.totalPriceOverrideAmount = this.productConfigData.defaults.totalPriceOverrideAmount || 0.0;
        }

        if (this.productConfigData.overrides && this.productConfigData.overrides.piecesOnSheetOverride) {
            this.overridePiecesOnSheet = this.productConfigData.overrides.piecesOnSheetOverride || 0;
        } else {
            this.overridePiecesOnSheet = this.productConfigData.defaults.overridePiecesOnSheet || 0;
        }

        if (this.productConfigData.overrides && this.productConfigData.overrides.coverPiecesOnSheetOverride) {
            this.overrideCoverPiecesOnSheet = this.productConfigData.overrides.coverPiecesOnSheetOverride || 0;
        } else {
            this.overrideCoverPiecesOnSheet = this.productConfigData.defaults.overrideCoverPiecesOnSheet || 0;
        }
    },

    initializeAdditionalFields: function () {
        this.additionalFields = {};
        var metadata = this.productConfigData.metadata;
        if (metadata) {
            for (var i = 0; i < metadata.length; i++) {
                var metadataItem = metadata[i];
                if (metadataItem.dataType === 'CB') {
                    this.additionalFields[metadataItem.name] = 'false';
                } else {
                    this.additionalFields[metadataItem.name] = '';
                }
            }
        }

        if (this.productConfigData.overrides && this.productConfigData.overrides.offeringMetadata) {
            var overridesAdditionalFields = this.productConfigData.overrides.offeringMetadata;
            for (var propName in overridesAdditionalFields) {
                var field = overridesAdditionalFields[propName];
                this.additionalFields[field.QUESTION] = field.ANSWER;
            }
        }
    },

    initializeQuantities: function () {
        if (this.productConfigData.overrides && this.productConfigData.overrides.quantity) {
            this.qty = this.productConfigData.overrides.quantity;
        } else {
            this.qty = this.productConfigData.defaults.quantity;
        }

        if (this.productConfigData.overrides && this.productConfigData.overrides.quantityPerVersion) {
            this.qtyPerVersion = this.productConfigData.overrides.quantityPerVersion;
        } else {
            this.qtyPerVersion = this.productConfigData.defaults.quantityPerVersion;
        }

        if (this.productConfigData.overrides && this.productConfigData.overrides.versions) {
            this.versions = this.productConfigData.overrides.versions;
        } else {
            var defaultQuantityPerVersions = this.qtyPerVersions || this.qty;

            this.versions = this.productConfigData.defaults.versions || [
                {
                    label: 'Version 1',
                    name: 'Version 1',
                    quantity: defaultQuantityPerVersions
                }
            ];
        }
    },

    initializePagesChoice: function () {
        if (this.productConfigData.overrides && this.productConfigData.overrides.pages) {
            this.pages = this.productConfigData.overrides.pages;
        } else {
            this.pages = this.productConfigData.defaults.pages || 0;
        }
    },

    initializeBleedChoice: function () {
        if (this.productConfigData.overrides && this.productConfigData.overrides.bleed != null) {
            this.bleed = this.productConfigData.overrides.bleed;
        } else {
            this.bleed = this.productConfigData.defaults.bleed || false;
        }
    },

    initializeDimensionsChoice: function () {
        if (this.productConfigData.overrides) {
            var dimensions = this.productConfigData.overrides.dimensions;

            if (this.isQuoteModePrivileged() || !dimensions.presetDimensionsId) {
                this.showCustomDimensions = true;
                this.width = dimensions.width;
                this.height = dimensions.height;
            } else {
                this.setPresetDimensionsChoice(dimensions.presetDimensionsId);
                if (!this.width || !this.height) {
                    this.width = dimensions.width;
                    this.height = dimensions.height;
                }
            }
        } else {
            var pjc = this.productConfigData.pjc;
            var defaultDimensions = this.productConfigData.defaults.dimensions;
            var notDefinedDimensions = defaultDimensions == null && pjc.showCustomDimensionsOption;
            var customDimensionSelected = defaultDimensions != null && defaultDimensions.presetDimensionsId == null;

            this.showCustomDimensions = notDefinedDimensions || customDimensionSelected || this.isQuoteModePrivileged();
            this.initDimensionsChoiceWithDefaults();
        }
    },

    initDimensionsChoiceWithDefaults: function () {
        var defaultDimensions = this.productConfigData.defaults.dimensions;

        if (defaultDimensions) {
            var defaultPresetDimensionsId = defaultDimensions.presetDimensionsId;
            var width = defaultDimensions.width;
            var height = defaultDimensions.height;

            if (defaultPresetDimensionsId) {
                this.setPresetDimensionsChoice(defaultPresetDimensionsId);
            }

            if (width !== undefined) {
                this.width = width;
            }

            if (height !== undefined) {
                this.height = height;
            }
        } else {
            this.width = 0;
            this.height = 0;
        }
    },

    initializeProofsChoice: function () {
        if (this.productConfigData.overrides && this.productConfigData.overrides.proofId) {
            var proofId = this.productConfigData.overrides.proofId;
            this.proofChoice = this.productConfigData.proofs.find(function (proof) {
                return proof.id === proofId;
            });

            if (!this.proofChoice) {
                this.initProofChoiceWithDefaults();
            }
        } else {
            this.initProofChoiceWithDefaults();
        }
    },

    initProofChoiceWithDefaults: function () {
        var defaultProofId = this.productConfigData.defaults.proofId;
        this.proofChoice = defaultProofId !== undefined ? this.productConfigData.proofs.find(function (proof) {
            return proof.id === defaultProofId;
        }) : null;
    },

    initializeTurnaroundTimesChoice: function () {
        if (this.productConfigData.overrides && this.productConfigData.overrides.turnaroundTimeId) {
            var turnaroundTimeId = this.productConfigData.overrides.turnaroundTimeId;
            this.turnaroundTimeChoice = this.productConfigData.turnaroundTimes.find(function (tt) {
                return tt.id === turnaroundTimeId;
            });

            if (!this.turnaroundTimeChoice) {
                this.initTurnaroundTimeChoiceWithDefaults();
            }
        } else {
            this.initTurnaroundTimeChoiceWithDefaults();
        }
    },

    initTurnaroundTimeChoiceWithDefaults: function () {
        var defaultTurnaroundTimeId = this.productConfigData.defaults.turnaroundTimeId;
        this.turnaroundTimeChoice = defaultTurnaroundTimeId !== undefined ? this.productConfigData.turnaroundTimes.find(function (tt) {
            return tt.id === defaultTurnaroundTimeId;
        }) : null;
    },

    initializePrivilegedModeFlags: function () {
        if (!this.isQuoteModePrivileged() || !this.productConfigData) {
            return;
        }

        var pjc = this.productConfigData.pjc;

        if (this.isShowCoverPressSheetType()) {
            pjc.editCoverPressSheetType = true;
        }

        if (this.isShowCoverPressSheetWeight()) {
            pjc.editCoverPressSheetWeight = true;
        }

        if (this.isShowCoverPressSheetColor()) {
            pjc.editCoverPressSheetColor = true;
        }

        if (this.isShowCoverSide1Ink()) {
            pjc.editCoverSide1Ink = true;
        }

        if (this.isShowCoverSide2Ink()) {
            pjc.editCoverSide2Ink = true;
            pjc.requireCoverSide2Ink = false;
        }

        if (this.isShowSide1Ink()) {
            pjc.editSide1Ink = true;
        }

        if (this.isShowSide2Ink()) {
            pjc.editSide2Ink = true;
            pjc.requireSide2Ink = false;
            pjc.matchSide1AndSide2Ink = false;
        }

        if (this.isShowPressSheetType()) {
            pjc.editPressSheetType = true;
        }

        if (this.isShowPressSheetWeight()) {
            pjc.editPressSheetWeight = true;
        }

        if (this.isShowPressSheetColor()) {
            pjc.editPressSheetColor = true;
        }
    },

    getPjcId: function () {
        return this.productConfigData.pjc.id;
    },

    getOfferingId: function () {
        return this.productConfigData.id;
    },

    isShowProofTip: function () {
        return this.productConfigData && this.productConfigData.showProofTip;
    },

    getProofTip: function () {
        return this.productConfigData.proofTip;
    },

    isShowProof: function () {
        return this.productConfigData && this.productConfigData.showProof;
    },

    isShowTurnaroundTime: function () {
        return this.productConfigData && this.productConfigData.showTurnaroundTime;
    },

    isShowTurnaroundTimeTip: function () {
        return this.productConfigData && this.productConfigData.showTurnaroundTimeTip;
    },

    getTurnaroundTimeTip: function () {
        return this.productConfigData.turnaroundTimeTip;
    },

    getProofs: function () {
        return this.productConfigData.proofs;
    },

    setProof: function (value) {
        this.proofChoice = this.productConfigData.proofs.find(function (proof) {
            return proof.id === +value;
        });
    },

    setTurnaroundTime: function (value) {
        this.turnaroundTimeChoice = this.productConfigData.turnaroundTimes.find(function (tt) {
            return tt.id === +value;
        });
    },

    getTurnaroundTimes: function () {
        return this.productConfigData.turnaroundTimes;
    },

    getProductAttributes: function () {
        return this.productConfigData.productAttributes;
    },

    addAdditionalField: function (question, answer) {
        this.additionalFields[question] = answer;
    },

    isEditProof: function () {
        return this.productConfigData && this.productConfigData.editProof;
    },

    isEditTurnaroundTime: function () {
        return this.productConfigData && this.productConfigData.editTurnaroundTime;
    },

    isQuoteModePrivileged: function () {
        return configuratorGlobals.isQuoteModePrivileged;
    },

    isShowDeviceTypes: function () {
        return this.productConfigData && this.productConfigData.pjc.showDeviceTypes;
    },

    isShowDeviceTypeTip: function () {
        return this.productConfigData && this.productConfigData.pjc.showDeviceTypeTip;
    },

    isEditDeviceType: function () {
        return this.productConfigData && this.productConfigData.pjc.editDeviceType;
    },

    isShowAutoDeviceOption: function () {
        return this.productConfigData && this.productConfigData.pjc.showAutoDeviceOption;
    },

    getDeviceChoices: function () {
        return this.getUniqueChoices(this.productConfigData.pjc.devices, function (dev) {
            return dev.type;
        }, function (type) {
            return type.id;
        });
    },

    getDeviceChoice: function () {
        return this.deviceChoice;
    },

    getDeviceLabel: function () {
        return this.isEditDeviceType() && this.isAutoDeviceSwitch()
            ? 'Printing Method (best price is chosen)'
            : 'Printing Method';
    },

    isAutoDeviceSwitch: function () {
        return this.autoDeviceSwitch;
    },

    setAutoDeviceSwitch: function (value) {
        this.autoDeviceSwitch = value;
    },

    isMultiPages: function () {
        return this.productConfigData && this.productConfigData.pjc.multiPages && this.productConfigData.pjc.multiPages === true;
    },

    isShowPressSheetType: function () {
        return this.productConfigData && this.productConfigData.pjc.showPressSheetType;
    },

    isEditCoverPressSheetType: function () {
        return this.productConfigData && this.productConfigData.pjc.editCoverPressSheetType;
    },

    isEditCoverPressSheetWeight: function () {
        return this.productConfigData && this.productConfigData.pjc.editCoverPressSheetWeight;
    },

    isEditCoverPressSheetColor: function () {
        return this.productConfigData && this.productConfigData.pjc.editCoverPressSheetColor;
    },

    isShowPressSheetTypeTip: function () {
        return this.productConfigData && this.productConfigData.pjc.showPressSheetTypeTip;
    },

    isShowPressSheetWeightTip: function () {
        return this.productConfigData && this.productConfigData.pjc.showPressSheetWeightTip;
    },

    isShowPressSheetColorTip: function () {
        return this.productConfigData && this.productConfigData.pjc.showPressSheetColorTip;
    },

    isShowPressSheetWeight: function () {
        return this.productConfigData && this.productConfigData.pjc.showPressSheetWeight;
    },

    isShowPressSheetColor: function () {
        return this.productConfigData && this.productConfigData.pjc.showPressSheetColor;
    },

    isEditPressSheetType: function () {
        return this.productConfigData && this.productConfigData.pjc.editPressSheetType;
    },

    isEditPressSheetWeight: function () {
        return this.productConfigData && this.productConfigData.pjc.editPressSheetWeight;
    },

    isEditPressSheetColor: function () {
        return this.productConfigData && this.productConfigData.pjc.editPressSheetColor;
    },

    isShowCoverPressSheetType: function () {
        return this.productConfigData && this.productConfigData.pjc.showCoverPressSheetType;
    },

    isShowCoverPressSheetTypeTip: function () {
        return this.productConfigData && this.productConfigData.pjc.showCoverPressSheetTypeTip;
    },

    isShowCoverPressSheetWeight: function () {
        return this.productConfigData && this.productConfigData.pjc.showCoverPressSheetWeight;
    },

    isShowCoverPressSheetWeightTip: function () {
        return this.productConfigData && this.productConfigData.pjc.showCoverPressSheetWeightTip;
    },

    isShowCoverPressSheetColorTip: function () {
        return this.productConfigData && this.productConfigData.pjc.showCoverPressSheetColorTip;
    },

    isShowCoverPressSheetColor: function () {
        return this.productConfigData && this.productConfigData.pjc.showCoverPressSheetColor;
    },

    isShowCoverSide1Ink: function () {
        return this.productConfigData && this.productConfigData.pjc.showCoverSide1Ink;
    },

    isShowSide1InkTip: function () {
        return this.productConfigData && this.productConfigData.pjc.showSide1InkTip;
    },

    isShowSide2InkTip: function () {
        return this.productConfigData && this.productConfigData.pjc.showSide2InkTip;
    },

    isShowCoverSide2Ink: function () {
        return this.productConfigData && this.productConfigData.pjc.showCoverSide2Ink;
    },

    isShowSide1Ink: function () {
        return this.productConfigData && this.productConfigData.pjc.showSide1Ink;
    },

    isEditSide1Ink: function () {
        return this.productConfigData && this.productConfigData.pjc.editSide1Ink;
    },

    isEditSide2Ink: function () {
        return this.productConfigData && this.productConfigData.pjc.editSide2Ink;
    },

    isShowSide2Ink: function () {
        return this.productConfigData && this.productConfigData.pjc.showSide2Ink;
    },

    isShowBleed: function () {
        return this.productConfigData && this.productConfigData.pjc.showBleed;
    },

    isShowBleedTip: function () {
        return this.productConfigData && this.productConfigData.pjc.showBleedTip;
    },

    isEditBleed: function () {
        return this.productConfigData && this.productConfigData.pjc.editBleed;
    },

    getBleed: function () {
        return this.bleed;
    },

    setBleed: function (newValue) {
        this.bleed = newValue;
    },

    getBleedLabel: function () {
        return 'Are there any Bleeds?';
    },

    getPressSheetTypeLabel: function () {
        return this.isMultiPages() ? 'Interior Pages Stock' : 'Paper Stock';
    },

    getPressSheetWeightLabel: function () {
        return this.isMultiPages() ? 'Interior Pages Weight' : 'Paper Weight';
    },

    getPressSheetColorLabel: function () {
        return this.isMultiPages() ? 'Interior Pages Color' : 'Paper Color';
    },

    getUniqueChoices: function (baseElements, choiceMappingFn, choiceKeyMappingFn) {
        if (!baseElements || baseElements.length === 0 || typeof choiceMappingFn !== 'function' || typeof choiceKeyMappingFn !== 'function') {
            return [];
        }

        var choiceElementByKey = new Map();

        baseElements.map(choiceMappingFn).forEach(function (choice) {
            var choiceKey = choiceKeyMappingFn(choice);
            if (choiceKey) {
                choiceElementByKey.set(choiceKey, choice);
            }
        });

        return Array.from(choiceElementByKey.values());
    },

    getPressSheets: function () {
        return this.isShowDeviceTypes() ? this.getPressSheetsFiltered() : this.productConfigData.pjc.pressSheets;
    },

    getPressSheetTypeChoices: function () {
        var pressSheets = this.getPressSheets();

        return this.getUniqueChoices(pressSheets, function (ps) {
            return ps.type;
        }, function (type) {
            return type.id;
        });
    },

    getCoverPressSheetTypeLabel: function () {
        return 'Cover Stock';
    },

    getCoverPressSheetWeightLabel: function () {
        return 'Cover Weight';
    },

    getCoverPressSheetColorLabel: function () {
        return 'Cover Color';
    },

    isShowDimensions: function () {
        return this.productConfigData && this.productConfigData.pjc.showDimensions;
    },

    getPresetDimensions: function () {
        return this.productConfigData && this.productConfigData.pjc.presetDimensions;
    },

    isShowCustomDimensionsByDefault: function () {
        return this.productConfigData && this.productConfigData.pjc.showCustomDimensionsOption;
    },

    setWidth: function (width) {
        this.width = width;
        this.tryUpdateMatchedPresetDimensions();
    },

    setHeight: function (height) {
        this.height = height;
        this.tryUpdateMatchedPresetDimensions();
    },

    tryUpdateMatchedPresetDimensions: function () {
        var presetDimensions = this.getPresetDimensions();
        var width = this.width;
        var height = this.height;

        var matched = presetDimensions.find(function (pd) {
            return pd.width === width && pd.height === height;
        });

        if (matched) {
            this.setPresetDimensionsChoice(matched.id);
        } else {
            this.presetDimensionsChoice = null;
        }
    },

    isShowCustomDimensions: function () {
        return this.showCustomDimensions;
    },

    setShowCustomDimensions: function (value) {
        this.showCustomDimensions = value;
    },

    getPresetDimensionsChoice: function () {
        return this.presetDimensionsChoice;
    },

    setPresetDimensionsChoice: function (presetDimensionId) {
        var presetDimensions = this.getPresetDimensions();
        this.presetDimensionsChoice = presetDimensions.find(function (pd) {
            return pd.id === presetDimensionId;
        });

        if (this.presetDimensionsChoice) {
            this.width = this.presetDimensionsChoice.width;
            this.height = this.presetDimensionsChoice.height;
        }
    },

    getWidth: function () {
        return this.width;
    },

    getHeight: function () {
        return this.height;
    },

    isShowDimensionsTip: function () {
        return this.productConfigData && this.productConfigData.pjc.showDimensionsTip;
    },

    isEditDimensions: function () {
        return this.productConfigData && this.productConfigData.pjc.editDimensions;
    },

    getDimensionsTitle: function () {
        return this.productConfigData && this.productConfigData.pjc.dimensionsTitle;
    },

    getDimensionsType: function () {
        return this.productConfigData && this.productConfigData.pjc.dimensionsType;
    },

    isShowPages: function () {
        return this.productConfigData && this.productConfigData.pjc.showPages;
    },

    isShowPagesTip: function () {
        return this.productConfigData && this.productConfigData.pjc.showPagesTip;
    },

    isEditPages: function () {
        return this.productConfigData && this.productConfigData.pjc.editPages;
    },

    setDevice: function (newValue) {
        var device = this.productConfigData.pjc.devices.find(function (dev) {
            return dev.type.id === +newValue;
        });

        this.deviceChoice = device ? device.type : null;
    },

    setPressSheetType: function (newValue) {
        this.pressSheetTypeChoice = this.getPressSheetTypeChoices().find(function (type) {
            return type.id === +newValue;
        });

        if (this.pressSheetTypeChoice) {
            var currentPressSheetTypeChoice = this.pressSheetTypeChoice;
            var currentPressSheetWeightChoice = this.pressSheetWeightChoice;

            var hasPressSheetWithSameWeight = this.getPressSheets().some(function (ps) {
                return ps.type.id === currentPressSheetTypeChoice.id && ps.weight.id === currentPressSheetWeightChoice.id;
            });

            if (!hasPressSheetWithSameWeight) {
                var pressSheetWeightChoices = this.getPressSheetWeightChoices();
                if (pressSheetWeightChoices.length > 0) {
                    this.setPressSheetWeight(pressSheetWeightChoices[0].id);
                }
            }
        }
    },

    setPressSheetWeight: function (newValue) {
        this.pressSheetWeightChoice = this.getPressSheetWeightChoices().find(function (weight) {
            return weight.id === +newValue;
        });

        if (this.pressSheetWeightChoice) {
            var currentPressSheetTypeChoice = this.pressSheetTypeChoice;
            var currentPressSheetWeightChoice = this.pressSheetWeightChoice;
            var currentPressSheetColorChoice = this.pressSheetColorChoice;

            var hasPressSheetWithSameColor = this.getPressSheets().some(function (ps) {
                return ps.type.id === currentPressSheetTypeChoice.id && ps.weight.id === currentPressSheetWeightChoice.id
                    && ps.color.id === currentPressSheetColorChoice.id;
            });

            if (!hasPressSheetWithSameColor) {
                var pressSheetColorChoices = this.getPressSheetColorChoices();
                if (pressSheetColorChoices.length > 0) {
                    this.setPressSheetColor(pressSheetColorChoices[0].id);
                }
            }
        }
    },

    setPressSheetColor: function (newValue) {
        this.pressSheetColorChoice = this.getPressSheetColorChoices().find(function (color) {
            return color.id === +newValue;
        });
    },

    setCoverPressSheetType: function (newValue) {
        this.coverPressSheetTypeChoice = this.getCoverPressSheetTypeChoices().find(function (type) {
            return type.id === +newValue;
        });

        if (this.coverPressSheetTypeChoice) {
            var currentCoverPressSheetTypeChoice = this.coverPressSheetTypeChoice;
            var currentCoverPressSheetWeightChoice = this.coverPressSheetWeightChoice;

            var hasCoverPressSheetWithSameWeight = this.getCoverPressSheets().some(function (ps) {
                return ps.type.id === currentCoverPressSheetTypeChoice.id && ps.weight.id === currentCoverPressSheetWeightChoice.id;
            });

            if (!hasCoverPressSheetWithSameWeight) {
                var coverPressSheetWeightChoices = this.getCoverPressSheetWeightChoices();
                if (coverPressSheetWeightChoices.length > 0) {
                    this.setCoverPressSheetWeight(coverPressSheetWeightChoices[0].id);
                }
            }
        }
    },

    setCoverPressSheetWeight: function (newValue) {
        this.coverPressSheetWeightChoice = this.getCoverPressSheetWeightChoices().find(function (weight) {
            return weight.id === +newValue;
        });

        if (this.coverPressSheetWeightChoice) {
            var currentCoverPressSheetTypeChoice = this.coverPressSheetTypeChoice;
            var currentCoverPressSheetWeightChoice = this.coverPressSheetWeightChoice;
            var currentCoverPressSheetColorChoice = this.coverPressSheetColorChoice;

            var hasCoverPressSheetWithSameColor = this.getCoverPressSheets().some(function (ps) {
                return ps.type.id === currentCoverPressSheetTypeChoice.id && ps.weight.id === currentCoverPressSheetWeightChoice.id
                    && ps.color.id === currentCoverPressSheetColorChoice.id;
            });

            if (!hasCoverPressSheetWithSameColor) {
                var coverPressSheetColorChoices = this.getCoverPressSheetColorChoices();
                if (coverPressSheetColorChoices.length > 0) {
                    this.setCoverPressSheetColor(coverPressSheetColorChoices[0].id);
                }
            }
        }
    },

    setCoverPressSheetColor: function (newValue) {
        this.coverPressSheetColorChoice = this.getCoverPressSheetColorChoices().find(function (color) {
            return color.id === +newValue;
        });
    },

    setSide1Ink: function (newValue) {
        var inkWithChosenType = this.getSide1Inks().find(function (ink) {
            return ink.type.id === +newValue;
        });
        this.side1InkChoice = inkWithChosenType ? inkWithChosenType.type : null;

        if (this.isMatchSide1AndSide2Ink()) {
            this.setSide2Ink(this.side1InkChoice.id);
        }
    },

    setSide2Ink: function (newValue) {
        var inkWithChosenType = this.getSide2Inks().find(function (ink) {
            return ink.type.id === +newValue;
        });
        this.side2InkChoice = inkWithChosenType ? inkWithChosenType.type : null;
    },

    setCoverSide1Ink: function (newValue) {
        var inkWithChosenType = this.getCoverSide1Inks().find(function (ink) {
            return ink.type.id === +newValue;
        });
        this.coverSide1InkChoice = inkWithChosenType ? inkWithChosenType.type : null;
    },

    setCoverSide2Ink: function (newValue) {
        var inkWithChosenType = this.getCoverSide2Inks().find(function (ink) {
            return ink.type.id === +newValue;
        });
        this.coverSide2InkChoice = inkWithChosenType ? inkWithChosenType.type : null;
    },

    getPagesLabel: function () {
        return 'Number of Pages';
    },

    getPages: function () {
        return this.pages;
    },

    setPages: function (pages) {
        this.pages = pages;
    },

    getTotalPriceOverrideAmount: function () {
        return this.totalPriceOverrideAmount;
    },

    getOverridePiecesOnSheet: function () {
        return this.overridePiecesOnSheet;
    },

    getOverrideCoverPiecesOnSheet: function () {
        return this.overrideCoverPiecesOnSheet;
    },

    getProductionGroup: function () {
        return this.productConfigData.productionGroup;
    },

    getCoverPressSheets: function () {
        return this.isShowDeviceTypes() ? this.getCoverPressSheetsFiltered() : this.productConfigData.pjc.coverPressSheets;
    },

    getCoverPressSheetTypeChoices: function () {
        var coverPressSheets = this.getCoverPressSheets();

        return this.getUniqueChoices(coverPressSheets, function (ps) {
            return ps.type;
        }, function (type) {
            return type.id;
        });
    },

    getCoverPressSheetTypeChoice: function () {
        return this.coverPressSheetTypeChoice;
    },

    getCoverPressSheetWeightChoices: function () {
        var coverPressSheetTypeChoice = this.coverPressSheetTypeChoice;
        var coverPressSheets = this.getCoverPressSheets().filter(function (ps) {
            return !coverPressSheetTypeChoice || ps.type.id === coverPressSheetTypeChoice.id;
        });

        return this.getUniqueChoices(coverPressSheets, function (ps) {
            return ps.weight;
        }, function (type) {
            return type.id;
        });
    },

    getCoverPressSheetColorChoice: function () {
        return this.coverPressSheetColorChoice;
    },

    getCoverPressSheetColorChoices: function () {
        var coverPressSheets = this.getCoverPressSheets();

        return this.getUniqueChoices(coverPressSheets, function (ps) {
            return ps.color;
        }, function (type) {
            return type.id;
        });
    },

    getCoverPressSheetWeightChoice: function () {
        return this.coverPressSheetWeightChoice;
    },

    getPressSheetWeightChoices: function () {
        var pressSheetTypeChoice = this.pressSheetTypeChoice;
        var pressSheets = this.getPressSheets().filter(function (ps) {
            return !pressSheetTypeChoice || ps.type.id === pressSheetTypeChoice.id;
        });

        return this.getUniqueChoices(pressSheets, function (ps) {
            return ps.weight;
        }, function (type) {
            return type.id;
        });
    },

    getPressSheetColorChoices: function () {
        var pressSheetTypeChoice = this.pressSheetTypeChoice;
        var pressSheetWeightChoice = this.pressSheetWeightChoice;
        var pressSheets = this.getPressSheets().filter(function (ps) {
            return (!pressSheetTypeChoice || ps.type.id === pressSheetTypeChoice.id)
                && (!pressSheetWeightChoice || ps.weight.id === pressSheetWeightChoice.id);
        });

        return this.getUniqueChoices(pressSheets, function (ps) {
            return ps.color;
        }, function (type) {
            return type.id;
        });
    },

    getPressSheetTypeChoice: function () {
        return this.pressSheetTypeChoice;
    },

    getPressSheetWeightChoice: function () {
        return this.pressSheetWeightChoice;
    },

    getPressSheetColorChoice: function () {
        return this.pressSheetColorChoice;
    },

    getSide1InksFiltered: function () {
        var productSide1Inks = this.getPermissibleProductSide1Inks();
        var deviceSide1Inks = this.getDeviceSide1Inks();

        var commonSide1Inks = this.getCommonElements(productSide1Inks, deviceSide1Inks);

        return this.filterForChosenDevice(commonSide1Inks, function (dev, ink) {
            return dev.inks && dev.inks.includes(ink.id);
        });
    },

    getSide2InksFiltered: function () {
        var productSide2Inks = this.getPermissibleProductSide2Inks();
        var deviceSide2Inks = this.getDeviceSide2Inks();

        var commonSide2Inks = this.getCommonElements(productSide2Inks, deviceSide2Inks);

        return this.filterForChosenDevice(commonSide2Inks, function (dev, ink) {
            return dev.inks && dev.inks.includes(ink.id);
        });
    },

    getCoverSide1InksFiltered: function () {
        var productCoverSide1Inks = this.getPermissibleProductCoverSide1Inks();
        var deviceCoverSide1Inks = this.getDeviceCoverSide1Inks();

        var commonCoverSide1Inks = this.getCommonElements(productCoverSide1Inks, deviceCoverSide1Inks);

        return this.filterForChosenDevice(commonCoverSide1Inks, function (dev, ink) {
            return dev.inks && dev.inks.includes(ink.id);
        });
    },

    getCoverSide2InksFiltered: function () {
        var productCoverSide2Inks = this.getPermissibleProductCoverSide2Inks();
        var deviceCoverSide2Inks = this.getDeviceCoverSide2Inks();

        var commonCoverSide2Inks = this.getCommonElements(productCoverSide2Inks, deviceCoverSide2Inks);

        return this.filterForChosenDevice(commonCoverSide2Inks, function (dev, ink) {
            return dev.inks && dev.inks.includes(ink.id);
        });
    },

    filterForChosenDevice: function (elements, filterFn) {
        if (!this.deviceChoice || typeof filterFn !== 'function') {
            return elements;
        }

        var devices = this.productConfigData.pjc.devices;
        var typeId = this.deviceChoice.id;

        var devicesWithChosenType = devices.filter(function (dev) {
            return dev.type && dev.type.id === typeId;
        });

        var filteredElements = [];
        devicesWithChosenType.forEach(function (dev) {
            for (var i = 0; i < elements.length; i++) {
                var el = elements[i];
                if (filterFn(dev, el)) {
                    filteredElements.push(el);
                }
            }
        });

        return filteredElements;
    },

    getPressSheetsFiltered: function () {
        var productPressSheets = this.getPermissibleProductPressSheets();
        var devicePressSheets = this.getDevicePressSheets();
        var commonPressSheets = this.getCommonElements(productPressSheets, devicePressSheets);

        return this.filterForChosenDevice(commonPressSheets, function (dev, ps) {
            return dev.pressSheets && dev.pressSheets.includes(ps.id);
        });
    },

    initializeDeviceChoice: function () {
        this.deviceChoice = null;

        if (this.isShowDeviceTypes() || this.isQuoteModePrivileged()) {
            var overrides = this.productConfigData.overrides;
            if (overrides && overrides.deviceId !== undefined) {
                this.initDeviceChoiceByDeviceId(overrides.deviceId);
            } else {
                var deviceDefaultId = this.productConfigData.defaults.deviceId;
                if (deviceDefaultId !== undefined) {
                    this.initDeviceChoiceByDeviceId(deviceDefaultId);
                }
            }
        }
    },

    initDeviceChoiceByDeviceId: function (deviceId) {
        var device = this.productConfigData.pjc.devices.find(function (dev) {
            return dev.id === deviceId;
        });

        if (device && device.type) {
            this.deviceChoice = device.type;
        }
    },

    initializePressSheetsChoice: function () {
        if (this.productConfigData.overrides && this.productConfigData.overrides.pressSheetId !== undefined) {
            this.initPressSheetChoices(this.productConfigData.overrides.pressSheetId);

            if (!this.pressSheetTypeChoice && !this.pressSheetWeightChoice && !this.pressSheetColorChoice) {
                this.initPressSheetChoiceWithDefaults();
            }
        } else {
            this.initPressSheetChoiceWithDefaults();
        }
    },

    initPressSheetChoices: function (pressSheetId) {
        var pressSheet = this.productConfigData.pjc.pressSheets.find(function (ps) {
            return ps.id === pressSheetId;
        });

        if (pressSheet) {
            this.pressSheetTypeChoice = pressSheet.type;
            this.pressSheetWeightChoice = pressSheet.weight;
            this.pressSheetColorChoice = pressSheet.color;
        }
    },

    initPressSheetChoiceWithDefaults: function () {
        var defaultPressSheetId = this.productConfigData.defaults.pressSheetId;

        if (defaultPressSheetId !== undefined) {
            this.initPressSheetChoices(defaultPressSheetId);
        } else {
            var pressSheetTypes = this.getPressSheetTypeChoices();
            this.pressSheetTypeChoice = pressSheetTypes.length > 0 ? pressSheetTypes[0] : null;

            var pressSheetWeights = this.getPressSheetWeightChoices();
            this.pressSheetWeightChoice = pressSheetWeights.length > 0 ? pressSheetWeights[0] : null;

            var pressSheetColors = this.getPressSheetColorChoices();
            this.pressSheetColorChoice = pressSheetColors.length > 0 ? pressSheetColors[0] : null;
        }
    },

    getCoverPressSheetsFiltered: function () {
        var productCoverPressSheets = this.getPermissibleProductCoverPressSheets();
        var devicePressSheets = this.getDeviceCoverPressSheets();
        var commonPressSheets = this.getCommonElements(productCoverPressSheets, devicePressSheets);

        return this.filterForChosenDevice(commonPressSheets, function (dev, ps) {
            return dev.coverPressSheets && dev.coverPressSheets.includes(ps.id);
        });
    },

    initializeCoverPressSheetsChoice: function () {
        if (this.productConfigData.overrides && this.productConfigData.overrides.coverPressSheetId !== undefined) {
            this.initCoverPressSheetChoices(this.productConfigData.overrides.coverPressSheetId);

            if (!this.coverPressSheetTypeChoice && !this.coverPressSheetWeightChoice && !this.coverPressSheetColorChoice) {
                this.initCoverPressSheetChoiceWithDefaults();
            }
        } else {
            this.initCoverPressSheetChoiceWithDefaults();
        }
    },

    initCoverPressSheetChoices: function (coverPressSheetId) {
        var coverPressSheet = this.productConfigData.pjc.coverPressSheets.find(function (ps) {
            return ps.id === coverPressSheetId;
        });

        if (coverPressSheet) {
            this.coverPressSheetTypeChoice = coverPressSheet.type;
            this.coverPressSheetWeightChoice = coverPressSheet.weight;
            this.coverPressSheetColorChoice = coverPressSheet.color;
        }
    },

    initCoverPressSheetChoiceWithDefaults: function () {
        var defaultCoverPressSheetId = this.productConfigData.defaults.coverPressSheetId;

        if (defaultCoverPressSheetId !== undefined) {
            this.initCoverPressSheetChoices(defaultCoverPressSheetId);
        } else {
            var coverPressSheetTypes = this.getCoverPressSheetTypeChoices();
            this.coverPressSheetTypeChoice = coverPressSheetTypes.length > 0 ? coverPressSheetTypes[0] : null;

            var coverPressSheetWeights = this.getCoverPressSheetWeightChoices();
            this.coverPressSheetWeightChoice = coverPressSheetWeights.length > 0 ? coverPressSheetWeights[0] : null;

            var coverPressSheetColors = this.getCoverPressSheetColorChoices();
            this.coverPressSheetColorChoice = coverPressSheetColors.length > 0 ? coverPressSheetColors[0] : null;
        }
    },

    getSide1InkLabel: function () {
        return this.isMultiPages() ? 'Pages Printing' : 'Printing on the Front';
    },

    isRequireSide2Ink: function () {
        return this.productConfigData && this.productConfigData.pjc.requireSide2Ink;
    },

    isRequireCoverSide2Ink: function () {
        return this.productConfigData && this.productConfigData.pjc.requireCoverSide2Ink;
    },

    getSide2InkLabel: function () {
        return this.isMultiPages() ? 'Pages Printing on Back' : 'Printing on the Back';
    },

    getSide1InkChoices: function () {
        var side1Inks = this.getSide1Inks();

        return this.getUniqueChoices(side1Inks, function (ink) {
            return ink.type;
        }, function (inkType) {
            return inkType.id;
        });
    },

    getCoverSide1Inks: function () {
        return this.isShowDeviceTypes() ? this.getCoverSide1InksFiltered() : this.productConfigData.pjc.coverSide1Inks;
    },

    getCoverSide1InkChoices: function () {
        var coverSide1Inks = this.getCoverSide1Inks();

        return this.getUniqueChoices(coverSide1Inks, function (ink) {
            return ink.type;
        }, function (inkType) {
            return inkType.id;
        });
    },

    getCoverSide2InkChoices: function () {
        var coverSide2Inks = this.getCoverSide2Inks();

        return this.getUniqueChoices(coverSide2Inks, function (ink) {
            return ink.type;
        }, function (inkType) {
            return inkType.id;
        });
    },

    getCoverSide1InkChoice: function () {
        return this.coverSide1InkChoice;
    },

    getCoverSide2InkChoice: function () {
        return this.coverSide2InkChoice;
    },

    getCoverSide1InkLabel: function () {
        return 'Cover printing, outside';
    },

    getCoverSide2InkLabel: function () {
        return 'Cover printing, inside';
    },

    isShowCoverSide1InkTip: function () {
        return this.productConfigData && this.productConfigData.pjc.showCoverSide1InkTip;
    },

    isShowCoverSide2InkTip: function () {
        return this.productConfigData && this.productConfigData.pjc.showCoverSide2InkTip;
    },

    isEditCoverSide1Ink: function () {
        return this.productConfigData && this.productConfigData.pjc.editCoverSide1Ink;
    },

    isEditCoverSide2Ink: function () {
        return this.productConfigData && this.productConfigData.pjc.editCoverSide2Ink;
    },

    getSide1InkChoice: function () {
        return this.side1InkChoice;
    },

    addVersions: function () {
        var newVersion = this.versions.length + 1;
        this.qty = this.qty + this.qtyPerVersion;
        var label = 'Version ' + newVersion;
        this.versions.push({ label: label, name: label, quantity: this.qtyPerVersion });
        this.recalculateQuantity();
    },

    removeVersions: function () {
        this.versions = [
            {
                label: 'Version 1',
                name: 'Version 1',
                quantity: this.qtyPerVersion
            }
        ];
        this.recalculateQuantity();
    },

    removeVersionAt: function (index) {
        if (+index >= 0 && +index < this.versions.length) {
            this.versions.splice(index, 1);
            this.updateVersionNames();
            this.recalculateQuantity();
        }
    },

    updateVersion: function (index, newName) {
        if (+index >= 0 && +index < this.versions.length) {
            var version = this.versions[index];
            version.name = newName === '' ? version.label : newName;
        }
    },

    recalculateQuantity: function () {
        this.qty = this.versions.map(function (v) {
            return v.quantity;
        }).reduce(function (prev, curr) {
            return prev + curr;
        });
    },

    updateQuantity: function (newValue) {
        this.qty = +newValue;

        this.updateQuantityPerVersion(this.qty);
    },

    updateQuantityPerVersion: function (newValue) {
        var qtyPerVersion = +newValue;
        this.qtyPerVersion = qtyPerVersion;
        this.versions.forEach(function (v) {
            v.quantity = qtyPerVersion;
        });
        this.recalculateQuantity();
    },

    updateVersionCount: function (newValue) {
        var versionCount = +newValue;
        var currentVersionCount = this.versions.length;

        if (versionCount > currentVersionCount) {
            for (var i = currentVersionCount; i < versionCount; i++) {
                this.addVersions();
            }
        } else if (versionCount < currentVersionCount) {
            for (var i = currentVersionCount - 1; i >= versionCount; i--) {
                this.removeVersion(i);
            }
            this.updateVersionNames();
        }
        this.recalculateQuantity();
    },

    removeVersion: function (i) {
        if (this.versions.length > 1) {
            var version = this.versions[i];
            this.versions.splice(this.versions.indexOf(version), 1);
        }
    },

    updateVersionNames: function () {
        for (var i = 0; i < this.versions.length; i++) {
            var version = this.versions[i];
            var oldLabel = version.label;
            var verNum = i + 1;
            version.label = 'Version ' + verNum;

            if (oldLabel === version.name) {
                version.name = version.label;
            }
        }
    },

    setQuoteRequestData: function (data) {
        this.quoteRequestData = data;
    },

    generateQuoteRequestData: function () {
        var overrides = {};

        overrides.autoDeviceSwitch = this.isAutoDeviceSwitch();
        if (!this.isAutoDeviceSwitch()) {
            overrides.autoDeviceSwitch = false;
            var deviceType = this.getDeviceChoice();
            var device = this.productConfigData.pjc.devices.find(function (dev) {
                return dev.type.id === deviceType.id;
            });
            if (device) {
                overrides.deviceId = device.id;
            }
        }

        overrides.width = this.getWidth() || 0;
        overrides.height = this.getHeight() || 0;

        if (this.totalPriceOverrideAmount !== undefined) {
            overrides.totalPriceOverrideAmount = +this.totalPriceOverrideAmount;
        }

        overrides.matchSide1AndSide2Ink = this.isMatchSide1AndSide2Ink();
        overrides.bleed = this.getBleed();

        var pages = this.getPages();
        if (pages !== undefined) {
            overrides.pages = +pages;
        }

        var pressSheetType = this.getPressSheetTypeChoice();
        if (pressSheetType) {
            overrides.pressSheetTypeId = pressSheetType.id;
        }

        var pressSheetWeight = this.getPressSheetWeightChoice();
        if (pressSheetWeight) {
            overrides.pressSheetWeightId = pressSheetWeight.id;
        }

        var pressSheetColor = this.getPressSheetColorChoice();
        if (pressSheetColor) {
            overrides.pressSheetColorId = pressSheetColor.id;
        }

        var piecesOnSheet = this.getOverridePiecesOnSheet();
        if (piecesOnSheet) {
            overrides.piecesOnSheet = piecesOnSheet;
        }

        var coverPressSheetType = this.getCoverPressSheetTypeChoice();
        if (coverPressSheetType) {
            overrides.coverPressSheetTypeId = coverPressSheetType.id;
        }

        var coverPressSheetWeight = this.getCoverPressSheetWeightChoice();
        if (coverPressSheetWeight) {
            overrides.coverPressSheetWeightId = coverPressSheetWeight.id;
        }

        var coverPressSheetColor = this.getCoverPressSheetColorChoice();
        if (coverPressSheetColor) {
            overrides.coverPressSheetColorId = coverPressSheetColor.id;
        }

        var coverPiecesOnSheet = this.getOverrideCoverPiecesOnSheet();
        if (coverPiecesOnSheet) {
            overrides.coverPiecesOnSheet = coverPiecesOnSheet;
        }

        var side1InkType = this.getSide1InkChoice();
        if (side1InkType) {
            var side1Ink = this.getSide1Inks().find(function (ink) {
                return ink.type.id === side1InkType.id;
            });
            if (side1Ink) {
                overrides.side1InkId = side1Ink.id;
            }
        } else {
            overrides.side1InkId = side1InkType;
        }

        var side2InkType = this.getSide2InkChoice();
        if (side2InkType) {
            var side2Ink = this.getSide2Inks().find(function (ink) {
                return ink.type.id === side2InkType.id;
            });
            if (side2Ink) {
                overrides.side2InkId = side2Ink.id;
            }
        } else {
            overrides.side2InkId = side2InkType;
        }

        var coverSide1InkType = this.getCoverSide1InkChoice();
        if (coverSide1InkType) {
            var coverSide1Ink = this.getCoverSide1Inks().find(function (ink) {
                return ink.type.id === coverSide1InkType.id;
            });
            if (coverSide1Ink) {
                overrides.coverSide1InkId = coverSide1Ink.id;
            }
        } else {
            overrides.coverSide1InkId = coverSide1InkType;
        }

        var coverSide2InkType = this.getCoverSide2InkChoice();
        if (coverSide2InkType) {
            var coverSide2Ink = this.getCoverSide2Inks().find(function (ink) {
                return ink.type.id === coverSide2InkType.id;
            });
            if (coverSide2Ink) {
                overrides.coverSide2InkId = coverSide2Ink.id;
            }
        } else {
            overrides.coverSide2InkId = coverSide2InkType;
        }

        overrides.operationChoices = Object.fromEntries(this.getOperationChoiceMap().entries());
        overrides.operationChoiceAnswersText = Object.fromEntries(this.getOperationAnswerMap().entries());
        overrides.operationChoiceAnswersInteger = Object.fromEntries(this.getOperationAnswerIntMap().entries());

        var data = {
            systemOfferingSiteShareId: this.productConfigData.id,
            proofId: this.proofChoice ? this.proofChoice.id : null,
            turnTimeId: this.turnaroundTimeChoice ? this.turnaroundTimeChoice.id : null,
            idWithPrefix: configureCommonGlobals.idWithPrefix,
            orderItemId: this.getOrderItemId(),
            forReorder: this.isReorderOrRequoteMode(),
            siteId: configureCommonGlobals.siteId,
            systemId: configureCommonGlobals.systemId,
            offeringId: getUrlParms().offeringId,
            quoteHistoryId: getUrlParms().OBJECTID3
        };

        if (this.versions.length > 1) {
            overrides.versionCount = this.versions.length;
            overrides.qtyPerVersion = this.qtyPerVersion;
            overrides.versionList = this.versions;
        } else {
            overrides.versionCount = this.versions.length;
            data.quantity = this.qty;
        }

        data.printJobQuoteSpecOverrides = overrides;
        this.setQuoteRequestData(data);

        return data;
    },

    getOrderItemId: function () {
        return getUrlParms().reorder || getUrlParms().orderItemId || getUrlParms().OBJECTID;
    },

    isReorderOrRequoteMode: function () {
        return (getUrlParms().reorder != null && getUrlParms().p == null) || configureCommonGlobals.REQUOTE_MODE;
    },

    getVersionQuantityLabel: function () {
        return 'Quantity per Version';
    },

    getQuantityLabel: function () {
        return 'Total Quantity';
    },

    getSide1Inks: function () {
        return this.isShowDeviceTypes() ? this.getSide1InksFiltered() : this.productConfigData.pjc.side1Inks;
    },

    initializeSide1InksChoice: function () {
        this.side1InkChoice = null;

        if (this.productConfigData.overrides) {
            this.initSide1InkChoiceByInkId(this.productConfigData.overrides.side1InkId);
        } else {
            var defaultSide1InkId = this.productConfigData.defaults.sideInk1Id;

            if (defaultSide1InkId === undefined) {
                return;
            }

            this.initSide1InkChoiceByInkId(defaultSide1InkId);
        }
    },

    initSide1InkChoiceByInkId: function (site1InkId) {
        var side1Inks = this.getSide1Inks();

        if (site1InkId !== undefined && side1Inks) {
            var side1Ink = side1Inks.find(function (ink) {
                return ink.id === site1InkId;
            });

            this.side1InkChoice = side1Ink ? side1Ink.type : null;
        }
    },

    isMatchSide1AndSide2Ink: function () {
        return this.productConfigData && this.productConfigData.pjc.matchSide1AndSide2Ink;
    },

    getSide2Inks: function () {
        return this.isShowDeviceTypes() ? this.getSide2InksFiltered() : this.productConfigData.pjc.side2Inks;
    },

    getSide2InkChoices: function () {
        if (this.isMatchSide1AndSide2Ink()) {
            return this.getSide1InkChoices();
        }

        var side2Inks = this.getSide2Inks();
        return this.getUniqueChoices(side2Inks, function (ink) {
            return ink.type;
        }, function (inkType) {
            return inkType.id;
        });
    },

    getSide2InkChoice: function () {
        return this.side2InkChoice;
    },

    initializeSide2InksChoice: function () {
        if (this.isMatchSide1AndSide2Ink()) {
            this.side2InkChoice = this.side1InkChoice;
        } else {
            this.side2InkChoice = null;

            if (this.productConfigData.overrides) {
                this.initSide2InkChoiceByInkId(this.productConfigData.overrides.side2InkId);
            } else {
                var defaultSide2InkId = this.productConfigData.defaults.sideInk2Id;

                if (defaultSide2InkId === undefined) {
                    return;
                }

                this.initSide2InkChoiceByInkId(defaultSide2InkId);
            }
        }
    },

    initSide2InkChoiceByInkId: function (site2InkId) {
        var side2Inks = this.getSide2Inks();

        if (site2InkId !== undefined && side2Inks) {
            var side2Ink = side2Inks.find(function (ink) {
                return ink.id === site2InkId;
            });

            this.side2InkChoice = side2Ink ? side2Ink.type : null;
        }
    },

    getPermissibleProductSide1Inks: function () {
        return this.getPermissibleObjects(this.productConfigData.pjc.side1Inks);
    },

    getPermissibleProductCoverSide1Inks: function () {
        return this.getPermissibleObjects(this.productConfigData.pjc.coverSide1Inks);
    },

    getDeviceCoverSide1Inks: function () {
        var inkIds = this.getIdsFromDevices(function (dev) {
            return dev.inks;
        });

        return this.productConfigData.pjc.coverSide1Inks.filter(function (ps) {
            return inkIds.includes(ps.id);
        });
    },

    getPermissibleProductCoverSide2Inks: function () {
        return this.getPermissibleObjects(this.productConfigData.pjc.coverSide2Inks);
    },

    getDeviceCoverSide2Inks: function () {
        var inkIds = this.getIdsFromDevices(function (dev) {
            return dev.inks;
        });

        return this.productConfigData.pjc.coverSide2Inks.filter(function (ps) {
            return inkIds.includes(ps.id);
        });
    },

    getDeviceSide1Inks: function () {
        var inkIds = this.getIdsFromDevices(function (dev) {
            return dev.inks;
        });

        return this.productConfigData.pjc.side1Inks.filter(function (ps) {
            return inkIds.includes(ps.id);
        });
    },

    getPermissibleProductSide2Inks: function () {
        return this.getPermissibleObjects(this.productConfigData.pjc.side2Inks);
    },

    getIdsFromDevices: function (elementsMappingFn) {
        if (!this.productConfigData || typeof elementsMappingFn === 'undefined') {
            return [];
        }

        return this.productConfigData.pjc.devices.flatMap(elementsMappingFn);
    },

    getDeviceSide2Inks: function () {
        var inkIds = this.getIdsFromDevices(function (dev) {
            return dev.inks;
        });

        return this.productConfigData.pjc.side2Inks.filter(function (ps) {
            return inkIds.includes(ps.id);
        });
    },

    applyPressSheetChoices: function (ps) {
        this.pressSheetTypeChoice = ps.type;
        this.pressSheetWeightChoice = ps.weight;
        this.pressSheetColorChoice = ps.color;
    },

    applyCoverPressSheetChoices: function (ps) {
        this.coverPressSheetTypeChoice = ps.type;
        this.coverPressSheetWeightChoice = ps.weight;
        this.coverPressSheetColorChoice = ps.color;
    },

    getDefaultPressSheet: function () {
        return this.productConfigData.pjc.pressSheets.find(function (ps) {
            return ps.defaultSelected;
        });
    },

    getDefaultCoverPressSheet: function () {
        return this.productConfigData.pjc.coverPressSheets.find(function (ps) {
            return ps.defaultSelected;
        });
    },

    getCommonElements: function (arr1, arr2) {
        var common = [];

        for (var i = 0; i < arr1.length; i++) {
            var obj = arr1[i];
            var id = obj.id;

            var another = arr2.find(function (o) {
                return o.id === id;
            });
            if (another) {
                common.push(obj);
            }
        }

        return common;
    },

    getDevicePressSheets: function () {
        var pressSheetIds = this.getIdsFromDevices(function (dev) {
            return dev.pressSheets;
        });

        return this.productConfigData.pjc.pressSheets.filter(function (ps) {
            return pressSheetIds.includes(ps.id);
        });
    },

    getDeviceCoverPressSheets: function () {
        var coverPressSheetIds = this.getIdsFromDevices(function (dev) {
            return dev.pressSheets;
        });

        return this.productConfigData.pjc.coverPressSheets.filter(function (ps) {
            return coverPressSheetIds.includes(ps.id);
        });
    },

    getCoverSide2Inks: function () {
        return this.isShowDeviceTypes() ? this.getCoverSide2InksFiltered() : this.productConfigData.pjc.coverSide2Inks;
    },

    initializeCoverSide1InksChoice: function () {
        if (this.productConfigData.overrides) {
            this.initCoverSide1InkChoiceByInkId(this.productConfigData.overrides.coverSide1InkId);
        } else {
            var defaultCoverSide1InkId = this.productConfigData.defaults.coverSideInk1Id;

            if (defaultCoverSide1InkId === undefined) {
                return;
            }

            this.initCoverSide1InkChoiceByInkId(defaultCoverSide1InkId);
        }
    },

    initCoverSide1InkChoiceByInkId: function (coverSite1InkId) {
        var coverSide1Inks = this.getCoverSide1Inks();

        if (coverSite1InkId !== undefined && coverSide1Inks) {
            var coverSide1Ink = coverSide1Inks.find(function (ink) {
                return ink.id === coverSite1InkId;
            });

            this.coverSide1InkChoice = coverSide1Ink ? coverSide1Ink.type : null;
        }
    },

    initializeCoverSide2InksChoice: function () {
        if (this.productConfigData.overrides) {
            this.initCoverSide2InkChoiceByInkId(this.productConfigData.overrides.coverSide2InkId);
        } else {
            var defaultCoverSide2InkId = this.productConfigData.defaults.coverSideInk2Id;

            if (defaultCoverSide2InkId === undefined) {
                return;
            }

            this.initCoverSide2InkChoiceByInkId(defaultCoverSide2InkId);
        }
    },

    initCoverSide2InkChoiceByInkId: function (coverSite2InkId) {
        var coverSide2Inks = this.getCoverSide2Inks();

        if (coverSite2InkId !== undefined && coverSide2Inks) {
            var coverSide2Ink = coverSide2Inks.find(function (ink) {
                return ink.id === coverSite2InkId;
            });

            this.coverSide2InkChoice = coverSide2Ink ? coverSide2Ink.type : null;
        }
    },

    getPermissibleObjects: function (allObjects) {
        return allObjects ? allObjects.filter(this.isPermissibleObject.bind(this)) : [];
    },

    isPermissible: function (adminOnly) {
        if (adminOnly) {
            var cuser = typeof globalpageglobals === 'object' && globalpageglobals.cuser;
            return cuser ? cuser.siteAdmin : USER_TYPE === 'SUPPLIER_ADMIN';
        }
        return true;
    },

    isPermissibleObject: function (obj) {
        return !('adminOnly' in obj) || this.isPermissible(obj.adminOnly);
    },

    getPermissibleProductPressSheets: function () {
        return this.getPermissibleObjects(this.productConfigData.pjc.pressSheets);
    },

    getPermissibleProductCoverPressSheets: function () {
        return this.getPermissibleObjects(this.productConfigData.pjc.coverPressSheets);
    },

    getOperationAnswerMap: function () {
        var operationAnswers = new Map();

        this.operations.filter(function (op) {
            return !op.itemAnswerIntType && op.itemAnswer !== undefined;
        }).forEach(function (op) {
            operationAnswers.set(op.pjcOperation.operation.id, op.itemAnswer);
        });

        return operationAnswers;
    },

    getOperationAnswerIntMap: function () {
        var operationAnswersInt = new Map();

        this.operations.filter(function (op) {
            return op.itemAnswerIntType && op.itemAnswerInt !== undefined;
        }).forEach(function (op) {
            operationAnswersInt.set(op.pjcOperation.operation.id, op.itemAnswerInt);
        });

        return operationAnswersInt;
    },

    getOperationChoiceMap: function () {
        var operationChoices = new Map();

        for (var i = 0; i < this.operations.length; i++) {
            var operation = this.operations[i];
            var operationId = operation.pjcOperation.operation.id;

            if (operation.choice) {
                operationChoices.set(operationId, operation.choice.id);
            } else {
                if (operation.choice === null) {
                    operationChoices.set(operationId, null);
                }
            }
        }

        return operationChoices;
    },

    setOperationChoice: function (operationId, selectionId) {
        var operation = this.operations.find(function (op) {
            return op.pjcOperation.operation.id === operationId;
        });

        if (operation) {
            if (isNaN(selectionId)) {
                operation.choice = null;
            } else {
                var choices = operation.choices;

                if (choices) {
                    operation.choice = choices.find(function (ch) {
                        return ch.id === selectionId;
                    });
                }
            }
        }
    },

    getEarliestDeliveryDate: function () {
        return configureCommonGlobals.earliestDeliveryDate;
    },

    isOverridePricing: function () {
        return this.productConfigData.overridePricing;
    },

    getPricingPrintJobClassificationId: function () {
        return this.productConfigData.pricingPrintJobClassificationId
            ? this.productConfigData.pricingPrintJobClassificationId
            : this.getPjcId();
    },

    getOfferingName: function () {
        return this.productConfigData.name;
    },

    getFulfillmentCenterId: function () {
        return this.productConfigData.systemOffering.fulfillmentCenterId;
    },

    getQuoteDefaults: function () {
        return this.productConfigData.quoteDefaults;
    },

    getTypeFilteredPressSheets: function () {
        var pressSheets = this.getPressSheets();
        var pressSheetTypeChoice = this.pressSheetTypeChoice;

        if (!pressSheetTypeChoice) {
            return pressSheets;
        }

        return pressSheets.filter(function (ps) {
            return ps.type.id === pressSheetTypeChoice.id;
        });
    },

    getTypeFilteredCoverPressSheets: function () {
        var coverPressSheets = this.getCoverPressSheets();
        var coverPressSheetTypeChoice = this.coverPressSheetTypeChoice;

        if (!coverPressSheetTypeChoice) {
            return coverPressSheets;
        }

        return coverPressSheets.filter(function (ps) {
            return ps.type.id === coverPressSheetTypeChoice.id;
        });
    },

    initializeOperations: function () {
        function comparingSequence (one, two) {
            return one.sequence - two.sequence;
        }

        function isIntegerType (modType) {
            return modType === 2 || modType === 3;
        }

        var sortedOperations = this.productConfigData.pjc.operations ? this.productConfigData.pjc.operations.toSorted(comparingSequence) : [];
        this.operations = [];

        for (var i = 0; i < sortedOperations.length; i++) {
            var op = sortedOperations[i];

            var defaultSelectedItem = op.items ? op.items.find(function (item) {
                return item.defaultSelected;
            }) : null;
            var operationDefaults = (this.productConfigData.defaults.operations || []).find(function (defOp) {
                return defOp.id === op.id;
            });
            var operationItemDefaults = operationDefaults ? operationDefaults.itemId : null;
            var defaultSelectedItemId = defaultSelectedItem ? defaultSelectedItem.id : null;
            var defaultChoiceId = operationItemDefaults || defaultSelectedItemId;

            var defaultChoice = op.items ? op.items.find(function (opIt) {
                return opIt.id === defaultChoiceId;
            }) : null;

            var sortedItems = op.items ? op.items.toSorted(comparingSequence) : [];
            var isIntAnswer = isIntegerType(op.itemQuestionModifierType);

            var itemQuestionDefaultAnswer = op.itemQuestionDefaultAnswer;
            var itemAnswerInt;

            if (this.productConfigData.overrides && this.productConfigData.overrides.operations) {
                var operationOverrides = this.productConfigData.overrides.operations.find(function (overridesOp) {
                    return overridesOp.operationId === op.id;
                });

                if (operationOverrides) {
                    itemQuestionDefaultAnswer = operationOverrides.itemAnswer;
                    itemAnswerInt = operationOverrides.itemAnswerInt;

                    if (operationOverrides.defaultSelectedChoice) {
                        defaultChoice = op.items ? op.items.find(function (opIt) {
                            return opIt.id === operationOverrides.defaultSelectedChoice;
                        }) : null;
                    } else {
                        // set up non default None choice
                        if (defaultChoiceId) {
                            defaultChoice = null;
                        }
                    }
                } else {
                    var defaultAnswers = this.prepareDefaultAnswers(op.id);
                    itemQuestionDefaultAnswer = defaultAnswers.defaultItemAnswer;
                    itemAnswerInt = defaultAnswers.defaultItemAnswerIntType;
                }
            } else {
                var defaultAnswers = this.prepareDefaultAnswers(op.id);
                itemQuestionDefaultAnswer = defaultAnswers.defaultItemAnswer;
                itemAnswerInt = defaultAnswers.defaultItemAnswerIntType;
            }

            var operationChoices = [];
            for (var ii = 0; ii < sortedItems.length; ii++) {
                var opItem = sortedItems[ii];

                if (!this.isPermissible(opItem.adminOnly)) {
                    continue;
                }

                if (op.editable || defaultChoiceId !== undefined) {
                    operationChoices.push({
                        id: opItem.id,
                        description: opItem.description,
                        name: opItem.name,
                        adminOnly: opItem.adminOnly
                    });
                }
            }

            this.operations.push({
                editable: op.editable,
                heading: op.heading,
                showItemQuestion: op.showItemQuestion,
                itemQuestion: op.itemQuestion,
                itemAnswerIntType: isIntAnswer,
                itemAnswerInt: itemAnswerInt,
                itemAnswer: itemQuestionDefaultAnswer,
                tipContent: op.tipContent,
                pjcOperation: {
                    id: op.id,
                    show: op.show,
                    showTip: op.showTip,
                    required: op.required,
                    operation: {
                        id: op.id,
                        description: op.description,
                        costingOnly: op.costingOnly
                    }
                },
                choices: operationChoices,
                choice: defaultChoice
            });
        }
    },

    prepareDefaultAnswers: function (operationId) {
        if (this.productConfigData.defaults.operations) {
            var defaultOp = this.productConfigData.defaults.operations.find(function (defOp) {
                return defOp.id === operationId;
            });

            if (defaultOp) {
                return {
                    defaultItemAnswer: defaultOp.itemAnswer,
                    defaultItemAnswerIntType: defaultOp.itemAnswerIntType
                };
            }
        }

        return {
            defaultItemAnswer: '',
            defaultItemAnswerIntType: 0
        };
    },

    isReorder: function () {
        return getUrlParms().reorder;
    },

    setTotalPriceOverrideAmount: function (amount) {
        this.totalPriceOverrideAmount = amount;
    },

    setPiecesOnSheetOverride: function (value) {
        this.overridePiecesOnSheet = value;
    },

    setCoverPiecesOnSheetOverride: function (value) {
        this.overrideCoverPiecesOnSheet = value;
    }

};

function OfferingAdapter (model) {
    this.model = model;
}

OfferingAdapter.prototype = {

    get id () {
        return this.model.getOfferingId();
    },

    get name () {
        return this.model.getOfferingName();
    },

    get quoteDefaults () {
        return this.model.getQuoteDefaults();
    },

    get systemLevelOffering () {
        return true;
    },

    get overridePricing () {
        return this.model.isOverridePricing();
    },

    get earliestDeliveryDate () {
        return this.model.getEarliestDeliveryDate();
    },

    get pricingPrintJobClassification () {
        return {
            id: this.model.getPricingPrintJobClassificationId()
        };
    },

    get productionGroup () {
        var productionGroup = this.model.getProductionGroup();
        return {
            id: productionGroup ? productionGroup.id : null,
            name: productionGroup ? productionGroup.name : null
        };
    },

    get systemOffering () {
        var model = this.model;
        var adapter = this;
        return {
            get pricingPrintJobClassification () {
                return {
                    id: model.getPricingPrintJobClassificationId()
                };
            },

            get fulfillmentCenter () {
                return {
                    id: model.getFulfillmentCenterId()
                };
            },

            isServiceTypePOD: function () {
                return true;
            },

            get showProofTip () {
                return model.isShowProofTip();
            },

            get proofTip () {
                return model.getProofTip();
            },

            get showTurnaroundTimeTip () {
                return model.isShowTurnaroundTimeTip();
            },

            get turnaroundTimeTip () {
                return model.getTurnaroundTimeTip();
            },

            get turnaroundTimes () {
                return adapter.getPublishedTurnaroundTimes();
            }
        };
    },

    get turnaroundTimes () {
        return this.getPublishedTurnaroundTimes();
    },

    get productAttributesValue () {
        return this.model.getProductAttributes();
    },

    isLargeFormatPOD: function () {
        return false;
    },

    isSmallFormatPOD: function () {
        return true;
    },

    getPublishedShowProof: function () {
        return this.model.isShowProof();
    },

    getPublishedShowTurnaroundTime: function () {
        return this.model.isShowTurnaroundTime();
    },

    getPublishedProofs: function () {
        var proofs = this.model.getProofs();
        return proofs ? proofs.map(function (proof) {
            return { proof: proof };
        }) : [];
    },

    getPublishedTurnaroundTimes: function () {
        var turnaroundTimes = this.model.getTurnaroundTimes();
        return turnaroundTimes ? turnaroundTimes.map(function (tt) {
            return { turnaroundTime: tt };
        }) : [];
    },

    getPublishedEditProof: function () {
        return this.model.isEditProof();
    },

    getPublishedEditTurnaroundTime: function () {
        return this.model.isEditTurnaroundTime();
    }

};

function OperationsManagerAdapter (model) {
    this.model = model;
}

OperationsManagerAdapter.prototype = {
    get operations () {
        return this.model.operations;
    },

    getOperationAt: function (index) {
        return index >= 0 && index < this.model.operations.length ? this.model.operations[index] : null;
    }
};

function OperationGroupSetManagerAdapter (model) {
    this.model = model;
}

OperationGroupSetManagerAdapter.prototype = {

    get operationGroups () {
        return this.model.operationGroups;
    }

};

function DeviceManagerAdapter (model) {
    this.model = model;
}

DeviceManagerAdapter.prototype = {

    get autoDeviceSwitch () {
        return this.model.isAutoDeviceSwitch();
    }

};

function PressSheetManagerAdapter (model) {
    this.model = model;
}

PressSheetManagerAdapter.prototype = {

    get typeFilteredElements () {
        return this.model.getTypeFilteredPressSheets();
    }

};

function CoverPressSheetManagerAdapter (model) {
    this.model = model;
}

CoverPressSheetManagerAdapter.prototype = {

    get typeFilteredElements () {
        return this.model.getTypeFilteredCoverPressSheets();
    }

};

function QuoteAdapter (model, quote) {
    this.model = model;
    for (var prop in quote) {
        this[prop] = quote[prop];
    }
}

QuoteAdapter.prototype = {

    get jobTotalPriceDisplay () {
        return this.priceDisplay;
    },

    get pjQuote () {
        var deviceId = this.deviceId;
        var deviceName = this.deviceName;
        var deviceTypeId = this.deviceTypeId;
        var pressSheetId = this.pressSheetId;
        var pressSheetName = this.pressSheetName;
        var pressSheetDescription = this.pressSheetDescription;
        var pressSheetTypeId = this.pressSheetTypeId;
        var pressSheetWeightId = this.pressSheetWeightId;
        var pressSheetColorId = this.pressSheetColorId;
        var pressSheetCaliper = this.pressSheetCaliper;

        var coverPressSheetId = this.coverPressSheetId;
        var coverPressSheetTypeId = this.coverPressSheetTypeId;
        var coverPressSheetWeightId = this.coverPressSheetWeightId;
        var coverPressSheetColorId = this.coverPressSheetColorId;
        var coverPressSheetCaliper = this.coverPressSheetCaliper;

        var pieceFinishedWidth = this.pieceFinishedWidth;
        var pieceFinishedHeight = this.pieceFinishedHeight;

        var pressSheetCount = this.pressSheetCount;
        var piecesOnSheet = this.piecesOnSheet;
        var side1InkName = this.side1InkName;
        var side2InkName = this.side2InkName;
        var side1Ink = side1InkName ? { name: side1InkName } : null;
        var side2Ink = side2InkName ? { name: side2InkName } : null;

        var totalOunces = this.totalOunces;
        var pressSheetHeight = this.pressSheetHeight;

        return {
            side1Ink: side1Ink,
            side2Ink: side2Ink,
            pressSheetQuote: {
                pressSheet: {
                    id: pressSheetId,
                    description: pressSheetDescription,
                    color: { id: pressSheetColorId },
                    weight: { id: pressSheetWeightId },
                    type: { id: pressSheetTypeId },
                    caliper: pressSheetCaliper,
                    name: pressSheetName
                },
                height: pressSheetHeight,
                pressSheetCount: pressSheetCount,
                piecesOnSheet: piecesOnSheet
            },
            coverPressSheetQuote: {
                pressSheet: {
                    id: coverPressSheetId,
                    color: { id: coverPressSheetColorId },
                    weight: { id: coverPressSheetWeightId },
                    type: { id: coverPressSheetTypeId },
                    caliper: coverPressSheetCaliper
                }
            },
            piece: {
                finishedWidth: pieceFinishedWidth,
                finishedHeight: pieceFinishedHeight
            },
            totalOunces: totalOunces,
            device: {
                id: deviceId,
                name: deviceName,
                type: {
                    id: deviceTypeId
                }
            }
        };
    }

};

function ExtendedQuoteAdapter (model, quote) {
    this.model = model;
    this.quoteRequestData = Object.assign({}, model.quoteRequestData, {
        additionalFields: model.additionalFields
    });
    this.javaClassName = 'TBGQuote';

    for (var prop in quote) {
        this[prop] = quote[prop];
    }
}

ExtendedQuoteAdapter.prototype = {

    get jobTotalPriceDisplay () {
        return this.priceDisplay;
    },

    get pjQuote () {
        var deviceName = this.deviceName;
        var deviceTypeName = this.deviceTypeName;
        var devicePrice = this.devicePrice;
        var runtime = this.runtime;

        var side1InkName = this.side1InkName;
        var side1InkTypeName = this.side1InkTypeName;
        var side1InkPrice = this.side1InkPrice;
        var side2InkName = this.side2InkName;
        var side2InkTypeName = this.side2InkTypeName;
        var side2InkPrice = this.side2InkPrice;

        var coverSide1InkName = this.coverSide1InkName;
        var coverSide1InkTypeName = this.coverSide1InkTypeName;
        var coverSide1InkPrice = this.coverSide1InkPrice;
        var coverSide2InkName = this.coverSide2InkName;
        var coverSide2InkTypeName = this.coverSide2InkTypeName;
        var coverSide2InkPrice = this.coverSide2InkPrice;

        var coverPressSheetPrice = this.coverPressSheetPrice;
        var pressSheetPrice = this.pressSheetPrice;
        var versionsPrice = this.versionsPrice;

        var quantity = this.quantity;
        var pages = this.pages;
        var pressRuns = this.pressRuns;
        var piecesPerQuantity = this.piecesPerQuantity;
        var pressSheetsThroughDevice = this.pressSheetsThroughDevice;
        var totalPressSheetCount = this.totalPressSheetCount;
        var jobCostPrice = this.jobCostPrice;
        var operationsPrice = this.operationsPrice;
        var markupType = this.markupType;
        var markupPercent = this.markupPercent;
        var markupPrice = this.markupPrice;
        var proofPrice = this.proofPrice;
        var turnaroundPrice = this.turnaroundPrice;
        var totalOunces = this.totalOunces;

        var coverPressSheetQuote = this.coverPressSheetQuote;
        var pressSheetQuote = this.pressSheetQuote;

        var piece = this.smallFormatPiece;
        var versions = this.versions;
        var operationQuotes = this.operationQuotes && this.operationQuotes.map(function (operationQuote) {
            return {
                pieces: operationQuote.pieces,
                data: {
                    heading: operationQuote.heading,
                    itemQuestion: operationQuote.itemQuestion,
                    itemAnswer: operationQuote.itemAnswer,
                    choice: {
                        name: operationQuote.operationItem.name
                    }
                }
            };
        });

        return {
            javaClassName: 'TBGPJQuote',
            devicePrice: devicePrice,
            runtime: runtime,
            side1InkPrice: side1InkPrice,
            side2InkPrice: side2InkPrice,
            coverSide1InkPrice: coverSide1InkPrice,
            coverSide2InkPrice: coverSide2InkPrice,
            coverPressSheetPrice: coverPressSheetPrice,
            pressSheetPrice: pressSheetPrice,
            versionsPrice: versionsPrice,
            quantity: quantity,
            pages: pages,
            pressRuns: pressRuns,
            piecesPerQuantity: piecesPerQuantity,
            pressSheetsThroughDevice: pressSheetsThroughDevice,
            totalPressSheetCount: totalPressSheetCount,
            jobCostPrice: jobCostPrice,
            operationsPrice: operationsPrice,
            markupType: markupType,
            markupPercent: markupPercent,
            markupPrice: markupPrice,
            proofPrice: proofPrice,
            turnaroundPrice: turnaroundPrice,
            totalOunces: totalOunces,

            device: {
                name: deviceName,
                type: {
                    name: deviceTypeName
                }
            },

            side1Ink: side1InkName ? {
                name: side1InkName,
                type: {
                    name: side1InkTypeName
                }
            } : null,

            side2Ink: side2InkName ? {
                name: side2InkName,
                type: {
                    name: side2InkTypeName
                }
            } : null,

            coverSide1Ink: coverSide1InkName ? {
                name: coverSide1InkName,
                type: {
                    name: coverSide1InkTypeName
                }
            } : null,

            coverSide2Ink: coverSide2InkName ? {
                name: coverSide2InkName,
                type: {
                    name: coverSide2InkTypeName
                }
            } : null,

            coverPressSheetQuote: coverPressSheetQuote,
            pressSheetQuote: pressSheetQuote,
            piece: piece,
            versions: versions,
            operationQuotes: operationQuotes,

            get: function (propertyName) {
                return this[propertyName];
            }
        };
    },

    toJSON: function () {
        return Object.assign({
            jobTotalPriceDisplay: this.jobTotalPriceDisplay,
            pjQuote: this.pjQuote
        }, this);
    }

};

function QuoteDataAdapter (model, quote) {
    this.model = model;
    this.quote = quote;

    try {
        var hasQuoteErrors = this.quote !== undefined && this.quote.errors !== undefined && this.quote.errors.length > 0;

        if (hasQuoteErrors) {
            var quoteValidationData = JSON.parse(this.quote.errors[0].detail);
            this.quoteValidation = new Validation(quoteValidationData);
        } else if (this.quote.validation) {
            var fieldMessages = this.quote.validation.fieldMessages ? this.quote.validation.fieldMessages.map(function (fm) {
                return {
                    fieldName: fm.fieldName,
                    value: fm.message
                };
            }) : [];
            this.quoteValidation = new Validation({
                globalErrorMessages: this.quote.validation.globalErrorMessages,
                globalInfoMessages: this.quote.validation.globalInfoMessages,
                jobQuoteFieldMessages: fieldMessages
            });
        } else {
            this.quoteValidation = new Validation({});
        }
    } catch (e) {
        this.quoteValidation = new Validation({});
    }
}

QuoteDataAdapter.prototype = {
    setProperty: function () {
    },

    get offeringId () {
        return this.model.getOfferingId();
    },

    get totalOunces () {
        return this.quote.totalOunces;
    },

    get proof () {
        return this.model.proofChoice;
    },

    setProof: function (newValue) {
        this.model.setProof(newValue);
    },

    get turnaroundTime () {
        return this.model.turnaroundTimeChoice;
    },

    setTurnaroundTime: function (newValue) {
        this.model.setTurnaroundTime(newValue);
    },

    get externallyGenerated () {
        return false;
    },

    get versions () {
        return this.model.versions;
    },

    get quantityLabel () {
        return 'Total Quantity';
    },

    get versionQuantityLabel () {
        return 'Quantity per Version';
    },

    get privilegedMode () {
        return this.model.isQuoteModePrivileged();
    },

    get quantity () {
        return this.model.qty;
    },

    get quantityPerVersion () {
        return this.model.qtyPerVersion;
    },

    updateQuantityPerVersion: function (newValue) {
        this.model.updateQuantityPerVersion(newValue);
    },

    updateVersionCount: function (newValue) {
        this.model.updateVersionCount(newValue);
    },

    updateQuantity: function (newValue) {
        this.model.updateQuantity(newValue);
    },

    get versionCount () {
        return this.model.versions.length;
    },

    addVersions: function () {
        this.model.addVersions();
    },

    removeVersions: function () {
        this.model.removeVersions();
    },

    removeVersionAt: function (index) {
        this.model.removeVersionAt(index);
    },

    updateVersion: function (index, newName) {
        this.model.updateVersion(index, newName);
    },

    addFieldError: function (fieldName, value) {
        this.validation.addFieldError(fieldName, value);
    },

    clearFieldErrors: function (fieldName) {
        this.validation.clearFieldErrors(fieldName);
    },

    addGlobalError: function (error) {
        this.validation.addGlobalError(error);
    },

    clearGlobalErrors: function () {
        this.validation.clearGlobalErrors();
    },

    get validation () {
        return this.quoteValidation;
    },

    get jobSpecOverrides () {
        return this.model.generateQuoteRequestData().printJobQuoteSpecOverrides;
    },

    get metadata () {
        return this.model.productConfigData.metadata;
    },

    get device () {
        return this.model.deviceChoice;
    },

    get multipleVersions () {
        return this.model.versions.length > 1;
    },

    get width () {
        return this.model.width;
    },

    get height () {
        return this.model.height;
    },

    setAdditionalField: function (question, answer) {
        this.model.addAdditionalField(question, answer);
    },

    get additionalFields () {
        return this.model.additionalFields;
    }

};

function Validation (quoteValidationData) {
    var globalErrorMessages = quoteValidationData.globalErrorMessages || [];

    this.hasGlobalErrorMessages = globalErrorMessages.length > 0;
    this.globalErrorMessages = globalErrorMessages.map(function (msg) {
        return {
            value: msg
        };
    });

    var globalInfoMessages = quoteValidationData.globalInfoMessages || [];

    this.hasGlobalInfoMessages = globalInfoMessages.length > 0;
    this.globalInfoMessages = globalInfoMessages.map(function (msg) {
        return {
            value: msg
        };
    });

    var jobQuoteFieldMessages = quoteValidationData.jobQuoteFieldMessages || [];

    this.hasJobQuoteMessages = quoteValidationData.length > 0;
    this.jobQuoteFieldMessages = jobQuoteFieldMessages;
}

Validation.prototype = {

    addFieldError: function (fieldName, value) {
        this.jobQuoteFieldMessages.push({ fieldName: fieldName, value: value });
    },

    clearFieldErrors: function (fieldName) {
        var jobQuoteFieldMessages = this.jobQuoteFieldMessages;
        var fieldErrors = jobQuoteFieldMessages.filter(function (msg) {
            return msg.fieldName === fieldName;
        });

        fieldErrors.forEach(function (error) {
            jobQuoteFieldMessages.splice(jobQuoteFieldMessages.indexOf(error), 1);
        });
    },

    addGlobalError: function (error) {
        this.globalErrorMessages.push({ value: error });
        this.hasGlobalErrorMessages = true;
    },

    clearGlobalErrors: function () {
        this.globalErrorMessages = [];
        this.hasGlobalErrorMessages = false;
    }
};

var controller = {
    model: new StandardConfigureModel(),

    QUOTE_URLS: {
        DEFAULT: '/rest/storefront/products/quotes',
        EXTENDED: '/rest/internal/supplierAdmin/products/quotes/extended',
        CUSTOM: '/rest/internal/supplierAdmin/products/quotes/custom',
        REQUOTE: '/rest/internal/supplierAdmin/products/quotes/requote'
    },
    USER_TYPES: {
        SUPPLIER_ADMIN: 'SUPPLIER_ADMIN'
    },

    initializeModelAndDisplay: function (productConfigData, operationGroups) {
        this.model.initialize(productConfigData, operationGroups);

        this.initializeAdapters();

        var configChangeDetails = {
            context: 'init',
            category: confUtil.INIT
        };

        this.getQuote(false, function () {
            this.generateUI(configChangeDetails, { list: [] });

            configureEvents.onCalcLoaded();
            configureEvents.onQuoteUpdated(configChangeDetails);
            controller.onSmallQuoteComplete(configureglobals.cquote != null);
        }.bind(this));

        if (typeof shippingCalcWidgetController == 'object') {
            shippingCalcWidgetController.initialize();
        }
    },
    initializeAdapters: function () {
        configureglobals.set('coffering', new OfferingAdapter(this.model));
        configureglobals.set('cpjc', this.model.productConfigData.pjc);
        configureglobals.set('coperationsmgr', new OperationsManagerAdapter(this.model));
        configureglobals.set('coperationgroupset', new OperationGroupSetManagerAdapter(this.model));
        configureglobals.set('cdevicemgr', new DeviceManagerAdapter(this.model));
        configureglobals.set('cpresssheetmgr', new PressSheetManagerAdapter(this.model));
        configureglobals.set('ccoverpresssheetmgr', new CoverPressSheetManagerAdapter(this.model));
    },
    fetchPjc: function () {
        var self = this;

        return new Promise(function (resolve, reject) {
            var supplierAdmin = USER_TYPE === 'SUPPLIER_ADMIN';

            var storefrontPath = '/api/product-configuration-service/product-configurations/offerings/';
            var adminPath = '/api/product-configuration-service/supplierAdmin/product-configurations/offerings/';

            var offeringPath = supplierAdmin ? adminPath : storefrontPath;
            var offeringsURL = offeringPath + configureCommonGlobals.idWithPrefix;

            var queryParams = [];

            if (supplierAdmin) {
                // Pages use different conventions. Some of them use OBJECTID to pass orderItemId, while others use orderItemId
                // Params from Order details requote frame
                if (hasValue(getUrlParms().OBJECTID) || hasValue(getUrlParms().OBJECTID2) || hasValue(getUrlParms().OBJECTID3)) {
                    if (hasValue(getUrlParms().OBJECTID)) {
                        queryParams.push('orderItemId=' + getUrlParms().OBJECTID);
                    }

                    if (hasValue(getUrlParms().OBJECTID2)) {
                        queryParams.push('productionRunId=' + getUrlParms().OBJECTID2);
                    }

                    if (hasValue(getUrlParms().OBJECTID3)) {
                        queryParams.push('quoteHistoryId=' + getUrlParms().OBJECTID3);
                    }
                }
                if (hasValue(getUrlParms().orderItemId)) {
                    queryParams.push('orderItemId=' + getUrlParms().orderItemId);
                }
            } else {
                if (getUrlParms().reorder != null) {
                    queryParams.push('orderItemId=' + getUrlParms().reorder);

                    // r=y is the site user's "reuse the original's artwork" choice. The product
                    // configuration service needs it to decide whether the share's reorderProof
                    // default replaces the proof inherited from the original item. Sent only on
                    // this storefront branch - a supplier-admin requote must keep inheriting.
                    // TTI-20736.
                    //
                    // p (the project id) must be absent. r=y alone does not mean "reorder": the
                    // "edit this item's configuration" URL for an item already in a project
                    // hardcodes r=y and always carries p (RegularOrderItemDTOMapperImpl:328,336),
                    // and that routes to updateProduct rather than a reorder. Without the p check,
                    // editing a project item's quantity would silently reset its proof. This is the
                    // same condition isReorderOrRequoteMode uses, and the same one behind the
                    // forReorder flag sent alongside this request (configurePODController.js:521).
                    if (getUrlParms().r === 'y' && getUrlParms().p == null) {
                        queryParams.push('reorderReuseFiles=true');
                    }
                }

                if (getUrlParms().sharedProductConfig) {
                    queryParams.push('sharedProductConfig=' + getUrlParms().sharedProductConfig);
                }
            }

            var queryParamsString = queryParams.join('&');

            if (queryParamsString.length > 0) {
                offeringsURL = offeringsURL + '?' + queryParamsString;
            }

            var accessTokenPromise = supplierAdmin ? self.fetchAccessToken() : Promise.resolve();

            accessTokenPromise.then(function (token) {
                $.ajax({
                    url: offeringsURL,
                    method: 'GET',
                    accept: 'application/json',
                    beforeSend: function (xhr) {
                        if (hasValue(token)) {
                            xhr.setRequestHeader('Authorization', 'Bearer ' + token);
                        }
                    },
                    success: function (productConfigData) {
                        resolve(productConfigData);
                    },
                    error: function () {
                        console.error('Error fetching product and PJC');
                        reject();
                    }
                });
            }).catch(function () {
                reject();
            });
        });
    },
    fetchOperationGroups: function () {
        return new Promise(function (resolve, reject) {
            var siteId = configureCommonGlobals.siteId;

            $.ajax({
                url: '/api/site-service/sites/' + siteId + '/config/operation-group-sets',
                method: 'GET',
                accept: 'application/json',
                success: function (operationGroups) {
                    resolve(operationGroups);
                },
                error: function () {
                    console.error('Error fetching operation groups');
                    reject();
                }
            });
        });
    },
    fetchAccessToken: function () {
        return new Promise(function (resolve, reject) {
            $.ajax({
                url: '/rest/internal/supplierAdmin/adminUsers/jwtFromSession',
                method: 'GET',
                accept: 'application/json',
                success: function (response) {
                    resolve(response.apiToken);
                },
                error: function () {
                    console.error('Error fetching operation groups');
                    reject();
                }
            });
        });
    },
    initialize: function () {
        Promise.all([this.fetchPjc(), this.fetchOperationGroups()]).then(function (data) {
            var productConfigData = data[0];
            var operationGroups = data[1].operationGroupSet !== null ? data[1].operationGroupSet.operationGroups : null;
            controller.initializeModelAndDisplay(productConfigData, operationGroups);
        });
    },
    generateUI: function (configChangeDetails, quoteInitWarningMessages) {
        this.display();

        if (this.model.isMultiPages()) {
            dynamic.setClass('printSettings', 'multipage');
        }
    },
    onLogin: function () {
        this.updateQuote({
            context: 'onLogin',
            category: confUtil.LOGIN
        });
    },
    generateDeviceChoices: function () {
        if ((this.model.isShowDeviceTypes() || this.model.isQuoteModePrivileged()) && dynamic.divIdExists('deviceType')) {
            var fieldName = 'DEVICEDD';
            var quote = configureglobals.cquote;
            var content = '';
            var error = common.validation.hasJobQuoteFieldMessagesFor(fieldName);

            var devicechoices = this.model.getDeviceChoices();
            var selecteddevicechoice = this.model.deviceChoice;

            var help = '';

            if (this.model.isShowDeviceTypeTip()) {
                help = tags.a('Help', 'javascript:help.tip(configureglobals.cpjc,\'deviceTypeTip\',\'' + TBGBOTip.DEVICES + '\')', {
                    id: 'deviceTypeTip',
                    cssClass: 'quoteHelp',
                    tabindex: '-1',
                    title: 'More Information'
                });
            }

            if (this.model.isEditDeviceType() || this.model.isQuoteModePrivileged()) {
                if (this.model.isAutoDeviceSwitch()) {
                    // if auto, the device isn't known until the quote is run.
                    content += help + '<label class="config">' + this.model.getDeviceLabel() + '</label>';
                    if (quote != null) {
                        content += tags.div(quote.deviceTypeName, {
                            id: 'deviceTypeFromQuote',
                            cssClass: 'noEdit'
                        });
                    }

                    if (this.model.isShowAutoDeviceOption() || this.model.isQuoteModePrivileged()) {
                        content += tags.a('Let me choose the print method', 'javascript:controller.setAutoDevice(false)', {
                            cssClass: 'togglePreset'
                        });
                    }
                } else {
                    content += help + '<label class="config">' + this.model.getDeviceLabel() + '</label>';
                    content += forms.dd(fieldName, devicechoices, selecteddevicechoice, {
                        showNullOption: false,
                        cssClass: 'configSelect' + (error ? ' error' : ''),
                        onchange: 'controller.setDevice()'
                    });

                    if (this.model.isShowAutoDeviceOption() || this.model.isQuoteModePrivileged()) {
                        content += tags.a('Use the print method with the best price', 'javascript:controller.setAutoDevice(true)', {
                            cssClass: 'togglePreset'
                        });
                    }
                    if (error) {
                        content += common.validation.generateJobQuoteFieldMessagesFor(fieldName);
                    }
                }
            } else {
                // if auto, the device isn't known until the quote is run.
                if (this.model.isAutoDeviceSwitch()) {
                    content += help + '<label class="config">' + this.model.getDeviceLabel() + '</label>';
                    if (quote != null) {
                        content += tags.div(quote.deviceName, {
                            id: 'deviceTypeFromQuote',
                            cssClass: 'noEdit'
                        });
                    }
                } else if (selecteddevicechoice != null) {
                    content += help + '<label class="config">' + this.model.getDeviceLabel() + '</label>';
                    content += tags.div(selecteddevicechoice.name, {
                        cssClass: 'noEdit'
                    });
                }
            }
            common.setOptionDiv('deviceType', content);
        }
    },
    setAutoDevice: function (auto) {
        var configChangeDetails = {
            context: 'setAutoDevice',
            category: confUtil.OPTION_CHANGE,
            value: auto,
            previousValue: !auto,
            newValue: auto
        };

        configureEvents.onCalcChanged(configChangeDetails);

        this.model.setAutoDeviceSwitch(auto);

        this.updateQuote(configChangeDetails);
    },
    setDevice: function () {
        var newValue = getDropDownSelectedValue('DEVICEDD', document);

        var configChangeDetails = {
            context: 'setDevice',
            category: confUtil.FIELD_CHANGE,
            fieldName: 'DEVICEDD',
            fieldType: 'DD',
            previousValue: null,
            newValue: newValue
        };
        configureEvents.onCalcChanged(configChangeDetails);

        this.model.setDevice(newValue);

        this.updateQuote(configChangeDetails);
    },
    getPressSheetTypeChoicesDivId: function () {
        return this.model.isMultiPages() ? 'pagesPressSheetType' : 'pressSheetType';
    },
    generatePressSheetTypeChoices: function () {
        var divId = this.getPressSheetTypeChoicesDivId();

        if (this.model.isShowPressSheetType() && dynamic.divIdExists(divId)) {
            var fieldName = 'PRESSSHEETTYPEDD';
            var content = '';
            var error = common.validation.hasJobQuoteFieldMessagesFor(fieldName);
            var typeLabel = this.model.getPressSheetTypeLabel();
            var choices = this.model.getPressSheetTypeChoices();
            var selected = this.model.getPressSheetTypeChoice();
            var help = '';

            if (this.model.isShowPressSheetTypeTip()) {
                help = tags.a('Help', 'javascript:help.tip(configureglobals.cpjc,\'pressSheetTypeTip\',\'' + TBGBOTip.PRESSSHEETTYPES + '\')', {
                    id: 'pressSheetTypeTip',
                    cssClass: 'quoteHelp',
                    tabindex: '-1',
                    title: 'More Information'
                });
            }

            if (this.model.isEditPressSheetType()) {
                content += help + '<label class="config">' + typeLabel + '</label>';
                content += forms.dd(fieldName, choices, selected, {
                    showNullOption: false,
                    cssClass: 'configSelect' + (error ? ' error' : ''),
                    onchange: 'controller.setPressSheetType()'
                });
                if (error) {
                    content += common.validation.generateJobQuoteFieldMessagesFor(fieldName);
                }
            } else {
                content += help + '<label class="config">' + typeLabel + '</label>';
                if (selected == null) {
                    content += tags.div('None', {
                        cssClass: 'noEdit'
                    });
                } else {
                    content += tags.div(selected.name, {
                        cssClass: 'noEdit'
                    });
                }
            }
            common.setOptionDiv(divId, content);
        }
    },
    setPressSheetType: function () {
        var newValue = getDropDownSelectedValue('PRESSSHEETTYPEDD', document);

        var configChangeDetails = {
            context: 'setPressSheetType',
            category: confUtil.FIELD_CHANGE,
            fieldName: 'PRESSSHEETTYPEDD',
            fieldType: 'DD',
            previousValue: null,
            newValue: newValue
        };
        configureEvents.onCalcChanged(configChangeDetails);

        this.model.setPressSheetType(newValue);

        this.updateQuote(configChangeDetails);
    },
    getPressSheetWeightChoicesDivId: function () {
        return this.model.isMultiPages() ? 'pagesPressSheetWeight' : 'pressSheetWeight';
    },
    generatePressSheetWeightChoices: function () {
        var divId = controller.getPressSheetWeightChoicesDivId();

        if (this.model.isShowPressSheetWeight() && dynamic.divIdExists(divId)) {
            var fieldName = 'PRESSSHEETWEIGHTDD';
            var content = '';
            var error = common.validation.hasJobQuoteFieldMessagesFor(fieldName);
            var pressSheetWeightLabel = this.model.getPressSheetWeightLabel();
            var choices = this.model.getPressSheetWeightChoices();
            var selected = this.model.getPressSheetWeightChoice();
            var help = '';

            if (this.model.isShowPressSheetWeightTip()) {
                help = tags.a('Help', 'javascript:help.tip(configureglobals.cpjc,\'pressSheetWeightTip\',\'' + TBGBOTip.PRESSSHEETWEIGHTS + '\')', {
                    id: 'pressSheetWeightTip',
                    cssClass: 'quoteHelp',
                    tabindex: '-1',
                    title: 'More Information'
                });
            }

            if (this.model.isEditPressSheetWeight()) {
                content += help + '<label class="config">' + pressSheetWeightLabel + '</label>';
                content += forms.dd(fieldName, choices, selected, {
                    showNullOption: false,
                    cssClass: 'configSelect' + (error ? ' error' : ''),
                    onchange: 'controller.setPressSheetWeight()'
                });
                if (error) {
                    content += common.validation.generateJobQuoteFieldMessagesFor(fieldName);
                }
            } else {
                content += help + '<label class="config">' + pressSheetWeightLabel + '</label>';
                if (selected == null) {
                    content += tags.div('None', {
                        cssClass: 'noEdit'
                    });
                } else {
                    content += tags.div(selected.name, {
                        cssClass: 'noEdit'
                    });
                }
            }
            common.setOptionDiv(divId, content);
        }
    },
    setPressSheetWeight: function () {
        var newValue = getDropDownSelectedValue('PRESSSHEETWEIGHTDD', document);

        var configChangeDetails = {
            context: 'setPressSheetWeight',
            category: confUtil.FIELD_CHANGE,
            fieldName: 'PRESSSHEETWEIGHTDD',
            fieldType: 'DD',
            previousValue: null,
            newValue: newValue
        };

        configureEvents.onCalcChanged(configChangeDetails);

        this.model.setPressSheetWeight(newValue);

        this.updateQuote(configChangeDetails);
    },
    getPressSheetColorChoicesDivId: function () {
        return this.model.isMultiPages() ? 'pagesPressSheetColor' : 'pressSheetColor';
    },
    generatePressSheetColorChoices: function () {
        var divId = controller.getPressSheetColorChoicesDivId();

        // if (configureglobals.cpjc.showPressSheetColor == true && dynamic.divIdExists(divId)) {
        if (this.model.isShowPressSheetColor() && dynamic.divIdExists(divId)) {
            var fieldName = 'PRESSSHEETCOLORDD';
            var content = '';
            var error = common.validation.hasJobQuoteFieldMessagesFor(fieldName);

            var pressSheetColorLabel = this.model.getPressSheetColorLabel();
            var choices = this.model.getPressSheetColorChoices();
            var selected = this.model.getPressSheetColorChoice();
            var help = '';

            // if (configureglobals.cpjc.showPressSheetColorTip) {
            if (this.model.isShowPressSheetColorTip()) {
                help = tags.a('Help', 'javascript:help.tip(configureglobals.cpjc,\'pressSheetColorTip\',\'' + TBGBOTip.PRESSSHEETCOLORS + '\')', {
                    id: 'pressSheetColorTip',
                    cssClass: 'quoteHelp',
                    tabindex: '-1',
                    title: 'More Information'
                });
            }

            // if (configureglobals.cpjc.editPressSheetColor == true) {
            if (this.model.isEditPressSheetColor()) {
                content += help + '<label class="config">' + pressSheetColorLabel + '</label>';
                content += forms.dd(fieldName, choices, selected, {
                    showNullOption: false,
                    cssClass: 'configSelect' + (error ? ' error' : ''),
                    onchange: 'controller.setPressSheetColor()'
                });
                if (error) {
                    content += common.validation.generateJobQuoteFieldMessagesFor(fieldName);
                }
            } else {
                content += help + '<label class="config">' + pressSheetColorLabel + '</label>';
                if (selected == null) {
                    content += tags.div('None', {
                        cssClass: 'noEdit'
                    });
                } else {
                    content += tags.div(selected.name, {
                        cssClass: 'noEdit'
                    });
                }
            }
            common.setOptionDiv(divId, content);
        }
    },
    setPressSheetColor: function () {
        var newValue = getDropDownSelectedValue('PRESSSHEETCOLORDD', document);

        var configChangeDetails = {
            context: 'setPressSheetColor',
            category: confUtil.FIELD_CHANGE,
            fieldName: 'PRESSSHEETCOLORDD',
            fieldType: 'DD',
            previousValue: null,
            newValue: newValue
        };

        this.model.setPressSheetColor(newValue);

        configureEvents.onCalcChanged(configChangeDetails);

        this.updateQuote(configChangeDetails);
    },
    getInkChoicesDivId: function () {
        return this.model.isMultiPages() ? 'pagesSide1Ink' : 'side1Ink';
    },
    generateInkChoices: function () {
        var divId = controller.getInkChoicesDivId();

        if (this.model.isShowSide1Ink() && dynamic.divIdExists(divId)) {
            var fieldName = 'SIDE1DD';
            var content = '';
            var side1inkchoices = this.model.getSide1InkChoices();
            var selectedside1inkchoice = this.model.getSide1InkChoice();
            var error = common.validation.hasJobQuoteFieldMessagesFor(fieldName);
            var help = '';

            if (this.model.isShowSide1InkTip()) {
                help = tags.a('Help', 'javascript:help.tip(configureglobals.cpjc,\'side1InkTip\',\'' + TBGBOTip.SIDE1INKS + '\')', {
                    id: 'side1InkTip',
                    cssClass: 'quoteHelp',
                    tabindex: '-1',
                    title: 'More Information'
                });
            }
            if (this.model.isEditSide1Ink()) {
                content += help + '<label class="config">' + this.model.getSide1InkLabel() + '</label>';
                content += forms.dd(fieldName, side1inkchoices, selectedside1inkchoice, {
                    showNullOption: false,
                    cssClass: 'configSelect' + (error ? ' error' : ''),
                    onchange: 'controller.setSide1Ink()'
                });
                if (error) {
                    content += common.validation.generateJobQuoteFieldMessagesFor(fieldName);
                }
            } else {
                if (selectedside1inkchoice != null) {
                    content += help + '<label class="config">' + this.model.getSide1InkLabel() + '</label>';
                    content += tags.div(selectedside1inkchoice.name, {
                        cssClass: 'noEdit'
                    });
                }
            }
            common.setOptionDiv(divId, content);
        }

        if (this.model.isShowSide2Ink() && !this.model.isMatchSide1AndSide2Ink()) {
            var fieldName = 'SIDE2DD';
            var content = '';
            var side2inkchoices = this.model.getSide2InkChoices();
            var selectedside2inkchoice = this.model.getSide2InkChoice();
            error = common.validation.hasJobQuoteFieldMessagesFor(fieldName);
            var help = '';

            if (this.model.isShowSide2InkTip()) {
                help = tags.a('Help', 'javascript:help.tip(configureglobals.cpjc,\'side2InkTip\',\'' + TBGBOTip.SIDE2INKS + '\')', {
                    id: 'side2InkTip',
                    cssClass: 'quoteHelp',
                    tabindex: '-1',
                    title: 'More Information'
                });
            }

            if (this.model.isEditSide2Ink()) {
                content += help + '<label class="config">' + this.model.getSide2InkLabel() + '</label>';
                content += forms.dd(fieldName, side2inkchoices, selectedside2inkchoice, {
                    showNullOption: !this.model.isRequireSide2Ink(),
                    nullOption: 'None',
                    cssClass: 'configSelect' + (error ? ' error' : ''),
                    onchange: 'controller.setSide2Ink()'
                });
                if (error) {
                    content += common.validation.generateJobQuoteFieldMessagesFor(fieldName);
                }
            } else {
                if (selectedside2inkchoice != null) {
                    content += help + '<label class="config">' + this.model.getSide2InkLabel() + '</label>';
                    content += tags.div(selectedside2inkchoice.name, {
                        cssClass: 'noEdit'
                    });
                }
            }
            common.setOptionDiv(this.model.isMultiPages() ? 'pagesSide2Ink' : 'side2Ink', content);
        }
    },
    setSide1Ink: function () {
        var newValue = getDropDownSelectedValue('SIDE1DD', document);
        var configChangeDetails = {
            context: 'setSide1Ink',
            category: confUtil.FIELD_CHANGE,
            fieldName: 'SIDE1DD',
            fieldType: 'DD',
            previousValue: null,
            newValue: newValue
        };

        this.model.setSide1Ink(newValue);

        configureEvents.onCalcChanged(configChangeDetails);

        this.updateQuote(configChangeDetails);
    },
    setSide2Ink: function () {
        var newValue = getDropDownSelectedValue('SIDE2DD', document);

        var configChangeDetails = {
            context: 'setSide2Ink',
            category: confUtil.FIELD_CHANGE,
            fieldName: 'SIDE2DD',
            fieldType: 'DD',
            previousValue: null,
            newValue: newValue
        };

        this.model.setSide2Ink(newValue);

        configureEvents.onCalcChanged(configChangeDetails);

        this.updateQuote(configChangeDetails);
    },
    generateCoverPressSheetTypeChoices: function () {
        if (this.model.isShowCoverPressSheetType() && dynamic.divIdExists('coverPressSheetType')) {
            var fieldName = 'COVERPRESSSHEETTYPEDD';
            var content = '';
            var error = common.validation.hasJobQuoteFieldMessagesFor(fieldName);
            var choices = this.model.getCoverPressSheetTypeChoices();
            var selected = this.model.getCoverPressSheetTypeChoice();
            var help = '';

            if (this.model.isShowCoverPressSheetTypeTip()) {
                help = tags.a('Help', 'javascript:help.tip(configureglobals.cpjc,\'coverPressSheetTypeTip\',\'' + TBGBOTip.COVERPRESSSHEETTYPES + '\')', {
                    id: 'coverPressSheetTypeTip',
                    cssClass: 'quoteHelp',
                    tabindex: '-1',
                    title: 'More Information'
                });
            }

            if (this.model.isEditCoverPressSheetType()) {
                content += help + '<label class="config">' + this.model.getCoverPressSheetTypeLabel() + '</label>';
                content += forms.dd(fieldName, choices, selected, {
                    showNullOption: false,
                    cssClass: 'configSelect' + (error ? ' error' : ''),
                    onchange: 'controller.setCoverPressSheetType()'
                });
                if (error) {
                    content += common.validation.generateJobQuoteFieldMessagesFor(fieldName);
                }
            } else {
                content += help + '<label class="config">' + this.model.getCoverPressSheetTypeLabel() + '</label>';
                if (selected == null) {
                    content += tags.div('None', {
                        cssClass: 'noEdit'
                    });
                } else {
                    content += tags.div(selected.name, {
                        cssClass: 'noEdit'
                    });
                }
            }
            common.setOptionDiv('coverPressSheetType', content);
        }
    },
    setCoverPressSheetType: function () {
        var newValue = getDropDownSelectedValue('COVERPRESSSHEETTYPEDD', document);

        var configChangeDetails = {
            context: 'setCoverPressSheetType',
            category: confUtil.FIELD_CHANGE,
            fieldName: 'COVERPRESSSHEETTYPEDD',
            fieldType: 'DD',
            previousValue: null,
            newValue: newValue
        };
        configureEvents.onCalcChanged(configChangeDetails);

        this.model.setCoverPressSheetType(newValue);

        this.updateQuote(configChangeDetails);
    },
    generateCoverPressSheetWeightChoices: function () {
        if (this.model.isShowCoverPressSheetWeight() && dynamic.divIdExists('coverPressSheetWeight')) {
            var fieldName = 'COVERPRESSSHEETWEIGHTDD';
            var content = '';
            var error = common.validation.hasJobQuoteFieldMessagesFor(fieldName);

            var choices = this.model.getCoverPressSheetWeightChoices();
            var selected = this.model.getCoverPressSheetWeightChoice();
            var help = '';

            if (this.model.isShowCoverPressSheetWeightTip()) {
                help = tags.a('Help', 'javascript:help.tip(configureglobals.cpjc,\'coverPressSheetWeightTip\',\'' + TBGBOTip.COVERPRESSSHEETWEIGHTS + '\')', {
                    id: 'coverPressSheetWeightTip',
                    cssClass: 'quoteHelp',
                    tabindex: '-1',
                    title: 'More Information'
                });
            }

            if (this.model.isEditCoverPressSheetWeight()) {
                content += help + '<label class="config">' + this.model.getCoverPressSheetWeightLabel() + '</label>';
                content += forms.dd(fieldName, choices, selected, {
                    showNullOption: false,
                    cssClass: 'configSelect' + (error ? ' error' : ''),
                    onchange: 'controller.setCoverPressSheetWeight()'
                });
                if (error) {
                    content += common.validation.generateJobQuoteFieldMessagesFor(fieldName);
                }
            } else {
                content += help + '<label class="config">' + this.model.getCoverPressSheetWeightLabel() + '</label>';
                if (selected == null) {
                    content += tags.div('None', {
                        cssClass: 'noEdit'
                    });
                } else {
                    content += tags.div(selected.name, {
                        cssClass: 'noEdit'
                    });
                }
            }
            common.setOptionDiv('coverPressSheetWeight', content);
        }
    },
    setCoverPressSheetWeight: function () {
        var newValue = getDropDownSelectedValue('COVERPRESSSHEETWEIGHTDD', document);

        var configChangeDetails = {
            context: 'setCoverPressSheetWeight',
            category: confUtil.FIELD_CHANGE,
            fieldName: 'COVERPRESSSHEETWEIGHTDD',
            fieldType: 'DD',
            previousValue: null,
            newValue: newValue
        };
        configureEvents.onCalcChanged(configChangeDetails);

        this.model.setCoverPressSheetWeight(newValue);

        this.updateQuote(configChangeDetails);
    },
    generateCoverPressSheetColorChoices: function () {
        if (this.model.isShowCoverPressSheetColor() && dynamic.divIdExists('coverPressSheetColor')) {
            var fieldName = 'COVERPRESSSHEETCOLORDD';
            var content = '';
            var error = common.validation.hasJobQuoteFieldMessagesFor(fieldName);

            var choices = this.model.getCoverPressSheetColorChoices();
            var selected = this.model.getCoverPressSheetColorChoice();
            var help = '';

            if (this.model.isShowCoverPressSheetColorTip()) {
                help = tags.a('Help', 'javascript:help.tip(configureglobals.cpjc,\'coverPressSheetColorTip\',\'' + TBGBOTip.COVERPRESSSHEETCOLORS + '\')', {
                    id: 'coverPressSheetColorTip',
                    cssClass: 'quoteHelp',
                    tabindex: '-1',
                    title: 'More Information'
                });
            }

            if (this.model.isEditCoverPressSheetColor()) {
                content += help + '<label class="config">' + this.model.getCoverPressSheetColorLabel() + '</label>';
                content += forms.dd(fieldName, choices, selected, {
                    showNullOption: false,
                    cssClass: 'configSelect' + (error ? ' error' : ''),
                    onchange: 'controller.setCoverPressSheetColor()'
                });
                if (error) {
                    content += common.validation.generateJobQuoteFieldMessagesFor(fieldName);
                }
            } else {
                content += help + '<label class="config">' + this.model.getCoverPressSheetColorLabel() + '</label>';
                if (selected == null) {
                    content += tags.div('None', {
                        cssClass: 'noEdit'
                    });
                } else {
                    content += tags.div(selected.name, {
                        cssClass: 'noEdit'
                    });
                }
            }
            common.setOptionDiv('coverPressSheetColor', content);
        }
    },
    setCoverPressSheetColor: function () {
        var newValue = getDropDownSelectedValue('COVERPRESSSHEETCOLORDD', document);

        var configChangeDetails = {
            context: 'setCoverPressSheetColor',
            category: confUtil.FIELD_CHANGE,
            fieldName: 'COVERPRESSSHEETCOLORDD',
            fieldType: 'DD',
            previousValue: null,
            newValue: newValue
        };
        configureEvents.onCalcChanged(configChangeDetails);

        this.model.setCoverPressSheetColor(newValue);

        this.updateQuote(configChangeDetails);
    },
    generateCoverInkChoices: function () {
        if (this.model.isShowCoverSide1Ink() && dynamic.divIdExists('coverSide1Ink')) {
            var fieldName = 'COVERSIDE1DD';
            var content = '';
            var choices = this.model.getCoverSide1InkChoices();
            var selectedchoice = this.model.getCoverSide1InkChoice();
            var error = common.validation.hasJobQuoteFieldMessagesFor(fieldName);
            var help = '';

            if (this.model.isShowCoverSide1InkTip()) {
                help = tags.a('Help', 'javascript:help.tip(configureglobals.cpjc,\'coverSide1InkTip\',\'' + TBGBOTip.COVERSIDE1INKS + '\')', {
                    id: 'coverSide1InkTip',
                    cssClass: 'quoteHelp',
                    tabindex: '-1',
                    title: 'More Information'
                });
            }

            if (this.model.isEditCoverSide1Ink()) {
                content += help + '<label class="config">' + this.model.getCoverSide1InkLabel() + '</label>';
                content += forms.dd(fieldName, choices, selectedchoice, {
                    showNullOption: false,
                    cssClass: 'configSelect' + (error ? ' error' : ''),
                    onchange: 'controller.setCoverSide1Ink()'
                });
                if (error) {
                    content += common.validation.generateJobQuoteFieldMessagesFor(fieldName);
                }
            } else {
                if (selectedchoice != null) {
                    content += help + '<label class="config">' + this.model.getCoverSide1InkLabel() + '</label>';
                    content += tags.div(selectedchoice.name, {
                        cssClass: 'noEdit'
                    });
                }
            }
            common.setOptionDiv('coverSide1Ink', content);
        }

        if (this.model.isShowCoverSide2Ink() && dynamic.divIdExists('coverSide2Ink')) {
            var fieldName = 'COVERSIDE2DD';
            var content = '';
            var choices = this.model.getCoverSide2InkChoices();
            var selectedchoice = this.model.getCoverSide2InkChoice();
            error = common.validation.hasJobQuoteFieldMessagesFor(fieldName);
            var help = '';

            if (this.model.isShowCoverSide1InkTip()) {
                help = tags.a('Help', 'javascript:help.tip(configureglobals.cpjc,\'coverSide2InkTip\',\'' + TBGBOTip.COVERSIDE2INKS + '\')', {
                    id: 'coverSide2InkTip',
                    cssClass: 'quoteHelp',
                    tabindex: '-1',
                    title: 'More Information'
                });
            }

            if (this.model.isEditCoverSide2Ink()) {
                content += help + '<label class="config">' + this.model.getCoverSide2InkLabel() + '</label>';
                content += forms.dd(fieldName, choices, selectedchoice, {
                    showNullOption: !this.model.isRequireCoverSide2Ink(),
                    nullOption: 'None',
                    cssClass: 'configSelect' + (error ? ' error' : ''),
                    onchange: 'controller.setCoverSide2Ink()'
                });
                if (error) {
                    content += common.validation.generateJobQuoteFieldMessagesFor(fieldName);
                }
            } else {
                if (selectedchoice != null) {
                    content += help + '<label class="config">' + this.model.getCoverSide2InkLabel() + '</label>';
                    content += tags.div(selectedchoice.name, {
                        cssClass: 'noEdit'
                    });
                }
            }
            common.setOptionDiv('coverSide2Ink', content);
        }
    },
    setCoverSide1Ink: function () {
        var newValue = getDropDownSelectedValue('COVERSIDE1DD', document);

        var configChangeDetails = {
            context: 'setCoverSide1Ink',
            category: confUtil.FIELD_CHANGE,
            fieldName: 'COVERSIDE1DD',
            fieldType: 'DD',
            previousValue: null,
            newValue: newValue
        };
        configureEvents.onCalcChanged(configChangeDetails);

        this.model.setCoverSide1Ink(newValue);

        this.updateQuote(configChangeDetails);
    },
    setCoverSide2Ink: function () {
        var newValue = getDropDownSelectedValue('COVERSIDE2DD', document);

        var configChangeDetails = {
            context: 'setCoverSide2Ink',
            category: confUtil.FIELD_CHANGE,
            fieldName: 'COVERSIDE2DD',
            fieldType: 'DD',
            previousValue: null,
            newValue: newValue
        };
        configureEvents.onCalcChanged(configChangeDetails);

        this.model.setCoverSide2Ink(newValue);

        this.updateQuote(configChangeDetails);
    },
    generateBleedDiv: function () {
        if (this.model.isShowBleed() && dynamic.divIdExists('bleedDiv')) {
            var fieldName = 'BLEEDDD';
            var content = '';
            var error = common.validation.hasJobQuoteFieldMessagesFor(fieldName);
            var isbleed = this.model.getBleed();
            var help = '';

            if (this.model.isShowBleedTip()) {
                help = tags.a('Help', 'javascript:help.tip(configureglobals.cpjc,\'bleedTip\',\'' + TBGBOTip.BLEED + '\')', {
                    id: 'bleedTip',
                    cssClass: 'quoteHelp',
                    tabindex: '-1',
                    title: 'More Information'
                });
            }

            if (this.model.isEditBleed()) {
                content += help + '<label class="config">' + this.model.getBleedLabel() + '</label>';
                var yes = new DDOption('Yes', 'Yes');
                content += forms.dd(fieldName, [yes], isbleed ? yes : null, {
                    nullOption: 'No',
                    cssClass: 'configSelect' + (error ? ' error' : ''),
                    onchange: 'controller.setBleed()'
                });
                if (error) {
                    content += common.validation.generateJobQuoteFieldMessagesFor(fieldName);
                }
            } else {
                content += help + '<label class="config">' + this.model.getBleedLabel() + '</label>';
                content += tags.div(isbleed ? 'Yes' : 'No', {
                    cssClass: 'noEdit'
                });
            }
            common.setOptionDiv('bleedDiv', content);
        }
    },
    setBleed: function () {
        var bleedDropdownValue = getDropDownSelectedValue('BLEEDDD', document);
        var isBleed = bleedDropdownValue === 'Yes';

        var configChangeDetails = {
            context: 'setBleed',
            category: confUtil.FIELD_CHANGE,
            fieldName: 'BLEEDDD',
            fieldType: 'DD',
            previousValue: null,
            newValue: bleedDropdownValue
        };
        configureEvents.onCalcChanged(configChangeDetails);

        this.model.setBleed(isBleed);

        this.updateQuote(configChangeDetails);
    },
    generateDimensionsDiv: function () {
        if ((this.model.isShowDimensions() || this.model.isQuoteModePrivileged()) && dynamic.divIdExists('dimensionsDiv')) {
            var widthName = 'WIDTHEF';
            var heightName = 'HEIGHTEF';
            var dimensionsName = 'PRESETDIMENSIONSDD';
            var customType = configureCommonGlobals.CUSTOM_DIMENSIONS;
            var presetType = configureCommonGlobals.PRESET_DIMENSIONS;
            var presetDimensions = this.model.getPresetDimensions();
            var content = '';
            var customDimensionsOption = this.model.isShowCustomDimensions();
            var presetDimensionsChoice = this.model.getPresetDimensionsChoice();
            var width = this.model.getWidth();
            var height = this.model.getHeight();
            var error = common.validation.hasJobQuoteFieldMessagesFor(widthName);
            var help = '';

            if (this.model.isShowDimensionsTip()) {
                help = tags.a('Help', 'javascript:help.tip(configureglobals.cpjc,\'dimensionsTip\',\'' + TBGBOTip.DIMENSIONS + '\')', {
                    id: 'dimensionsTip',
                    cssClass: 'quoteHelp',
                    tabindex: '-1',
                    title: 'More Information'
                });
            }

            if (this.model.isEditDimensions() || this.model.isQuoteModePrivileged()) {
                content += help + '<label class="config">' + this.model.getDimensionsTitle() + '</label>';
                var dimType = this.model.getDimensionsType();
                if (dimType == customType || customDimensionsOption) {
                    content += '<div class="customDimensions">';
                    content += forms.ef(widthName, width, {
                        size: 5,
                        cssClass: 'configField' + (error ? ' error' : ''),
                        onfocus: 'common.efFocus(\'' + widthName + '\',\'dimensionsDiv\', \'dimensionsFocus\')',
                        onblur: 'controller.setWidth()'
                    });
                    content += ' &#215; ';
                    content += forms.ef(heightName, height, {
                        size: 5,
                        cssClass: 'configField' + (error ? ' error' : ''),
                        onfocus: 'common.efFocus(\'' + heightName + '\',\'dimensionsDiv\', \'dimensionsFocus\')',
                        onblur: 'controller.setHeight()'
                    });
                    content += '<span id="dimensionsFocus" class="changeFocusButton"><!-- dynamic --></span>';
                    content += '</div>';
                    if (dimType == presetType && customDimensionsOption) {
                        content += tags.a('Use Preset Dimensions', 'javascript:controller.setCustomDimensionsOption(false)', {
                            cssClass: 'togglePreset presets'
                        });
                    }
                } else if (dimType == presetType) {
                    var ddoptions = {
                        showNullOption: false,
                        cssClass: 'configSelect' + (error ? ' error' : ''),
                        onchange: 'controller.setDimensions()',
                        propertyFunction: function (object) {
                            return object.width + ' x ' + object.height;
                        }
                    };
                    content += forms.dd(dimensionsName, presetDimensions, presetDimensionsChoice, ddoptions);
                    if (dimType == presetType && this.model.isShowCustomDimensionsByDefault()) {
                        content += tags.a('Use Custom Dimensions', 'javascript:controller.setCustomDimensionsOption(true)', {
                            cssClass: 'togglePreset customs'
                        });
                    }
                }
                if (error) {
                    content += common.validation.generateJobQuoteFieldMessagesFor(widthName);
                }
            } else {
                content += help + '<label class="config">' + this.model.getDimensionsTitle() + '</label>';
                content += tags.div(width + ' x ' + height, {
                    cssClass: 'noEdit'
                });
            }
            common.setOptionDiv('dimensionsDiv', content);
        }
    },
    setCustomDimensionsOption: function (bool) {
        var configChangeDetails = {
            context: 'setCustomDimensionsOption',
            category: confUtil.OPTION_CHANGE,
            value: bool,
            previousValue: !bool,
            newValue: bool
        };
        configureEvents.onCalcChanged(configChangeDetails);

        this.model.setShowCustomDimensions(bool);

        if (bool === false) {
            var presetDimensionsChoices = this.model.getPresetDimensions();
            var currentWidth = this.model.getWidth();
            var currentHeight = this.model.getHeight();
            var dimensionChoice = presetDimensionsChoices.find(function (dimension) {
                return dimension.width === currentWidth && dimension.height === currentHeight;
            });

            if (dimensionChoice) {
                this.model.setPresetDimensionsChoice(dimensionChoice.id);
            } else {
                this.model.initDimensionsChoiceWithDefaults();
            }
        }

        this.updateQuote(configChangeDetails);
    },
    setDimensions: function () {
        var newValue = getDropDownSelectedValue('PRESETDIMENSIONSDD', document);

        var configChangeDetails = {
            context: 'setDimensions',
            category: confUtil.FIELD_CHANGE,
            fieldName: 'PRESETDIMENSIONSDD',
            fieldType: 'DD',
            previousValue: null,
            newValue: newValue
        };
        configureEvents.onCalcChanged(configChangeDetails);

        this.model.setPresetDimensionsChoice(+newValue);

        this.updateQuote(configChangeDetails);
    },
    generatePagesDiv: function () {
        if (this.model.isShowPages() && dynamic.divIdExists('pagesDiv')) {
            var fieldName = 'PAGESEF';
            var content = '';
            var pages = this.model.getPages();
            var error = common.validation.hasJobQuoteFieldMessagesFor(fieldName);
            var help = '';

            if (this.model.isShowPagesTip()) {
                help = tags.a('Help', 'javascript:help.tip(configureglobals.cpjc,\'pagesTip\',\'' + TBGBOTip.PAGES + '\')', {
                    id: 'pagesTip',
                    cssClass: 'quoteHelp',
                    tabindex: '-1',
                    title: 'More Information'
                });
            }

            if (this.model.isEditPages()) {
                content += help + '<label class="config">' + this.model.getPagesLabel() + '</label>';
                content += forms.ef(fieldName, pages, {
                    size: 5,
                    cssClass: 'configField' + (error ? ' error' : ''),
                    onfocus: 'common.efFocus(\'' + fieldName + '\',\'pagesDiv\', \'pagesFocus\')',
                    onblur: 'controller.setPages()'
                });
                content += '<span id="pagesFocus" class="changeFocusButton"><!-- dynamic --></span>';
                if (error) {
                    content += common.validation.generateJobQuoteFieldMessagesFor(fieldName);
                }
            } else {
                content += help + '<label class="config">' + this.model.getPagesLabel() + '</label>';
                content += tags.div(pages, {
                    cssClass: 'noEdit'
                });
            }
            common.setOptionDiv('pagesDiv', content);
            if (error) {
                common.setCQuote(null);
            }
        }
    },
    generatePiecesOnSheetOverrideDiv: function () {
        // if (dynamic.divIdExists('piecesOnSheetOverrideDiv') && configuratorGlobals.isQuoteModePrivileged) {
        if (dynamic.divIdExists('piecesOnSheetOverrideDiv') && this.model.isQuoteModePrivileged()) {
            var fieldName = 'PIECES_ON_SHEET_OVERRIDE_EF';
            var content = '';
            var error = common.validation.hasJobQuoteFieldMessagesFor(fieldName);

            // var pjQuote = configureglobals.cquote ? configureglobals.cquote.pjQuote : null;
            var overridePiecesOnSheet = this.model.getOverridePiecesOnSheet() || 'Auto';// pjQuote && pjQuote.pressSheetQuote.piecesOnSheetOverride > 0 ? pjQuote.pressSheetQuote.piecesOnSheetOverride : 'Auto';
            content += '<label class="config">Pieces On Sheet</label>';
            content += forms.ef(fieldName, overridePiecesOnSheet, {
                style: 'width:70px',
                cssClass: 'configField' + (error ? ' error' : ''),
                onfocus: 'common.efFocus(\'' + fieldName + '\',\'piecesOnSheetOverrideDiv\', \'piecesOnSheetOverrideFocus\')',
                onblur: 'controller.setPiecesOnSheetOverride()'
            });
            content += '<span id="piecesOnSheetOverrideFocus" class="changeFocusButton"><!-- dynamic --></span>';
            if (overridePiecesOnSheet != 'Auto') {
                content += tags.a('Auto Calculate', 'javascript:controller.setDefaultPiecesOnSheet()', {
                    cssClass: 'togglePreset'
                });
            }
            if (error) {
                content += common.validation.generateJobQuoteFieldMessagesFor(fieldName);
            }
            common.setOptionDiv('piecesOnSheetOverrideDiv', content);
        }
    },
    setDefaultPiecesOnSheet: function () {
        // simulate the user clearing the field.
        setFieldValue('PIECES_ON_SHEET_OVERRIDE_EF', '', null);
        common.efBlur('PIECES_ON_SHEET_OVERRIDE_EF', 'piecesOnSheetOverrideDiv', 'piecesOnSheetOverrideFocus', function (newValue) {
            controller.model.setPiecesOnSheetOverride(null);
        });
    },
    generateCoverPiecesOnSheetOverrideDiv: function () {
        if (dynamic.divIdExists('coverPiecesOnSheetOverrideDiv') && this.model.isQuoteModePrivileged()) {
            var fieldName = 'COVER_PIECES_ON_SHEET_OVERRIDE_EF';
            var content = '';
            var error = common.validation.hasJobQuoteFieldMessagesFor(fieldName);

            var overridePiecesOnSheet = this.model.getOverrideCoverPiecesOnSheet() || 'Auto';// pjQuote && pjQuote.coverPressSheetQuote.piecesOnSheetOverride > 0 ? pjQuote.coverPressSheetQuote.piecesOnSheetOverride : 'Auto';
            content += '<label class="config">Pieces on Cover Sheet</label>';
            content += forms.ef(fieldName, overridePiecesOnSheet, {
                style: 'width:70px',
                cssClass: 'configField' + (error ? ' error' : ''),
                onfocus: 'common.efFocus(\'' + fieldName + '\',\'coverPiecesOnSheetOverrideDiv\', \'coverPiecesOnSheetOverrideFocus\')',
                onblur: 'controller.setCoverPiecesOnSheetOverride()'
            });
            content += '<span id="coverPiecesOnSheetOverrideFocus" class="changeFocusButton"><!-- dynamic --></span>';
            if (overridePiecesOnSheet != 'Auto') {
                content += tags.a('Auto Calculate', 'javascript:controller.setDefaultCoverPiecesOnSheet()', {
                    cssClass: 'togglePreset'
                });
            }
            if (error) {
                content += common.validation.generateJobQuoteFieldMessagesFor(fieldName);
            }
            common.setOptionDiv('coverPiecesOnSheetOverrideDiv', content);
        }
    },
    setDefaultCoverPiecesOnSheet: function () {
        setFieldValue('COVER_PIECES_ON_SHEET_OVERRIDE_EF', '', null);
        common.efBlur('COVER_PIECES_ON_SHEET_OVERRIDE_EF', 'coverPiecesOnSheetOverrideDiv', 'coverPiecesOnSheetOverrideFocus', function (newValue) {
            controller.model.setCoverPiecesOnSheetOverride(null);
        });
    },
    generateOverrideAmountDiv: function () {
        if (dynamic.divIdExists('overrideAmountDiv') && this.model.isQuoteModePrivileged()) {
            var fieldName = 'TOTAL_PRICE_OVERRIDE_AMOUNT_EF';
            var content = '';
            var totalPriceOverrideAmount = this.model.getTotalPriceOverrideAmount();
            var error = common.validation.hasJobQuoteFieldMessagesFor(fieldName);

            content += '<h3>Price Adjustment</h3>';
            content += forms.ef(fieldName, totalPriceOverrideAmount, {
                size: 15,
                style: 'width:auto',
                cssClass: 'configField' + (error ? ' error' : ''),
                onfocus: 'common.efFocus(\'' + fieldName + '\',\'overrideAmountDiv\', \'overrideAmountFocus\')',
                onblur: 'controller.setTotalPriceOverrideAmount()'
            });
            content += '<span id="overrideAmountFocus" class="changeFocusButton"><!-- dynamic --></span>';
            if (error) {
                content += common.validation.generateJobQuoteFieldMessagesFor(fieldName);
            }
            common.setOptionDiv('overrideAmountDiv', content);
        }
    },
    operationEntryFields: null,
    generateOperationsDiv: function () {
        this.operationEntryFields = [];

        var content = '';

        var operations = this.model.operations;
        var operationGroups = this.model.operationGroups;

        // TT-363 fallout: privileged mode reveals operations the storefront hides, but
        // prepareOperationGroupData drops anything that is not visible. Visibility has to be
        // resolved for every operation BEFORE grouping -- a hidden operation that belongs to a
        // group is otherwise discarded and can never be revealed. An ungrouped one survives via
        // the automatic 'Other' group, which is why this only bites sites that have an
        // operation group set linked.
        resolveOperationVisibility(operations);

        var groupData = prepareOperationGroupData(operationGroups, operations);

        if (groupData.length && operations) {
            for (var i = 0, className = ''; i < groupData.length; i++) {
                className = generateClassName(groupData[i].label);

                content += '<div class="operationsGroupWrapper operationsGroupWrapper--' + className + '">';
                content += '<h3>' + groupData[i].label + '</h3>';
                content += '<fieldset class="operationsGroup">';
                for (var j = 0; j < groupData[i].operations.length; j++) {
                    content += prepareOperationMarkup(groupData[i].operations[j], groupData[i].operations[j].originalIndex);
                }
                content += '</fieldset>';
                content += '</div>';
            }
        } else if (operations) {
            for (var i = 0; i < operations.length; i++) {
                content += prepareOperationMarkup(operations[i], i);
            }
        }

        if (content.length && !operationGroups) {
            content = '<h3>Finishing</h3><fieldset class="operationsGroup">' + content + '</fieldset>';
        }

        if (!content.length) {
            dynamic.setClass('operationsDiv', 'optionWrapperEmpty');
        } else {
            dynamic.setClass('operationsDiv', '');
        }

        dynamic.setDivIdContent('operationsDiv', content);

        return;

        function generateClassName (label) {
            return label
                .trim()
                .toLowerCase()
                .replace(/\s\s*/g, '-');
        }

        // Resolves, for each operation, whether it renders at all and whether it renders as
        // "internal only". Kept out of prepareOperationMarkup so that grouping and markup agree
        // on one answer, and deliberately does NOT mutate pjcOperation.show: the model outlives a
        // render, so a mutated flag would leak into the next pass.
        function resolveOperationVisibility (opData) {
            if (!opData) {
                return;
            }

            var privileged = configuratorGlobals.isQuoteModePrivileged;

            for (var oi = 0; oi < opData.length; oi++) {
                var op = opData[oi];
                var configuredShow = op.pjcOperation.show === true;
                var choiceCount = op.choices ? op.choices.length : 0;

                op.internalOnly = privileged && !configuredShow;
                // an internal-only operation with fewer than two choices offers nothing to pick
                op.visible = op.internalOnly ? choiceCount >= 2 : configuredShow;
            }
        }

        function prepareOperationMarkup (operationData, i) {
            var content = '';
            var ddName = 'OPERATIONDD';
            var cpjcoperation = operationData.pjcOperation;
            var coperationchoices = operationData.choices;
            var cchoice = operationData.choice;
            var help = '';
            var dderror,
                efName,
                fieldName,
                eferror;
            var internalOnly = operationData.internalOnly;
            var getChoiceDisplayName = function (cchoice) {
                var displayName = cchoice.name;
                if (cchoice.adminOnly) {
                    displayName += ' (Internal Only)';
                }
                return displayName;
            };

            // visibility and the internal-only flag are resolved up front, before grouping
            if (configuratorGlobals.isQuoteModePrivileged) {
                operationData.editable = true;
            }

            if (operationData.visible) {
                if (cpjcoperation.showTip) {
                    help = tags.a('', 'javascript:help.opTip(' + i + ')', {
                        id: 'opTip' + i,
                        cssClass: 'quoteHelp',
                        tabindex: '-1',
                        title: 'More Information'
                    });
                }

                content += '<div class="optionWrapperOn' + (cpjcoperation.operation.costingOnly ? ' costingOnly' : '') + '" id="operation' + cpjcoperation.operation.id + '">';
                if (internalOnly) {
                    content += help + '<label class="config internal-only">' + strWeb(operationData.heading) + ' (Internal Only)</label>';
                } else {
                    content += help + '<label class="config">' + strWeb(operationData.heading) + '</label>';
                }

                if (operationData.editable) {
                    dderror = common.validation.hasJobQuoteFieldMessagesFor(ddName + i);

                    content += forms.dd(ddName + i, coperationchoices, cchoice, {
                        showNullOption: !cpjcoperation.required,
                        nullOption: 'None',
                        cssClass: dderror ? 'opSelectError' : 'opSelect',
                        onchange: 'controller.setOperation(' + i + ',' + cpjcoperation.operation.id + ')',
                        id: 'operation' + cpjcoperation.operation.id,
                        propertyFunction: getChoiceDisplayName
                    });

                    if (dderror) {
                        content += common.validation.generateJobQuoteFieldMessagesFor(ddName + i);
                    }

                    // item question
                    if (cchoice && operationData.showItemQuestion) {
                        efName = 'OPERATIONITEMANSWEREF';
                        fieldName = efName + i;
                        eferror = common.validation.hasJobQuoteFieldMessagesFor(fieldName);

                        content += '<div id="operationItemDiv' + i + '" class="op">';
                        content += '<label class="opQuestion">' + operationData.itemQuestion + '</label>';
                        content += forms.ef(fieldName, operationData.itemAnswerIntType ? operationData.itemAnswerInt : strWeb(operationData.itemAnswer), {
                            id: 'operationAnswer' + cpjcoperation.operation.id,
                            size: 22,
                            cssClass: 'configField' + (eferror ? ' error' : ''),
                            onfocus: 'controller.onFocusOperationAnswer(\'' + fieldName + '\', ' + i + ')',
                            onblur: 'controller.onBlurOperationAnswer(\'' + fieldName + '\', ' + i + ')'

                            // onfocus: 'common.efFocus(\'' + fieldName + '\',\'operationItemDiv' + i + '\', \'operationFocus' + i + '\')',
                            // onblur: 'common.efBlur(\'' + fieldName + '\',\'operationItemDiv' + i + '\', \'operationFocus' + i + '\')'
                        });
                        content += '<span id="operationFocus' + i + '" class="changeFocusButton"><!-- dynamic --></span>';

                        controller.operationEntryFields[controller.operationEntryFields.length] = fieldName;

                        if (eferror) {
                            content += common.validation.generateJobQuoteFieldMessagesFor(fieldName);
                        }

                        content += '</div>';
                    }
                } else {
                    if (cchoice) {
                        content += tags.div(strWeb(cchoice.name), {
                            cssClass: 'noEdit'
                        });
                    }
                }

                content += '</div><!-- optionWrapper -->';
            }

            return content;
        }

        function prepareOperationGroupData (groups, opData) {
            var operationGroupData = [];
            var operations;

            if (!groups || !groups.length || !opData) {
                return operationGroupData;
            }

            // We are going to alter the array, make a copy of it
            // to leave original intact for other users
            operationData = opData.slice();

            // Save original index for use in things like tips etc...
            for (var i = 0; i < operationData.length; i++) {
                operationData[i].originalIndex = i;
            }

            // Loop through groups and match any listed operations
            // to operationData items returned for this product
            for (var j = 0, entry, tempOperations; j < groups.length; j++) {
                entry = {
                    label: groups[j].label,
                    operations: []
                };

                tempOperations = [];

                for (var k = 0, ii; k < groups[j].operations.length; k++) {
                    ii = 0;
                    while (ii < operationData.length) {
                        if (groups[j].operations[k].id === operationData[ii].pjcOperation.operation.id) {
                            if (operationData[ii].visible) {
                                tempOperations.push(operationData[ii]);
                            }
                            operationData.splice(ii, 1);
                            continue;
                        }
                        ii++;
                    }
                }

                if (tempOperations.length) {
                    entry.operations = tempOperations;
                    operationGroupData.push(entry);
                }
            }

            // If there are any operationData items not sorted into a group yet,
            // add them to a catch all group
            if (operationData.length) {
                operationGroupData.push({
                    label: 'Other',
                    operations: operationData
                });
            }

            return operationGroupData;
        }
    },
    setTotalPriceOverrideAmount: function () {
        if (common.validateTotalPriceOverrideAmount(controller.generateOverrideAmountDiv.bind(controller))) {
            return;
        }
        common.efBlur('TOTAL_PRICE_OVERRIDE_AMOUNT_EF', 'overrideAmountDiv', 'overrideAmountFocus', function (newValue) {
            controller.model.setTotalPriceOverrideAmount(+newValue.replace(/,/g, ''));
        });
    },
    setPiecesOnSheetOverride: function () {
        common.efBlur('PIECES_ON_SHEET_OVERRIDE_EF', 'piecesOnSheetOverrideDiv', 'piecesOnSheetOverrideFocus', function (newValue) {
            controller.model.setPiecesOnSheetOverride(+newValue);
        });
    },
    setCoverPiecesOnSheetOverride: function () {
        common.efBlur('COVER_PIECES_ON_SHEET_OVERRIDE_EF', 'coverPiecesOnSheetOverrideDiv', 'coverPiecesOnSheetOverrideFocus', function (newValue) {
            controller.model.setCoverPiecesOnSheetOverride(+newValue);
        });
    },
    setPages: function () {
        var cquotedata = configureglobals.cquotedata;
        var enteredPages = getFormItemValue('PAGESEF', document);

        cquotedata.clearFieldErrors('PAGESEF');
        var isValidPages = !isNaN(enteredPages) && !isNaN(parseInt(enteredPages));
        if (!isValidPages) {
            cquotedata.addFieldError('PAGESEF', 'Pages must be a number.');
            this.model.setPages(null);
            this.generatePagesDiv();
        } else {
            common.efBlur('PAGESEF', 'pagesDiv', 'pagesFocus', function (newValue) {
                controller.model.setPages(+newValue);
            });
        }
    },
    setWidth: function () {
        this.validateAndSetDimension('WIDTHEF', 'setWidth', 'Width must be a number.');
    },
    setHeight: function () {
        this.validateAndSetDimension('HEIGHTEF', 'setHeight', 'Height must be a number.');
    },

    validateAndSetDimension: function (fieldName, context, errorFieldValue) {
        var cquotedata = configureglobals.cquotedata;
        var enteredDimension = getFormItemValue(fieldName, document);

        var isEmpty = !enteredDimension || !enteredDimension.trim().length;
        if (isEmpty || isNumber(enteredDimension)) {
            common.efBlur(fieldName, 'dimensionsDiv', 'dimensionsFocus', function (newValue) {
                if (fieldName === 'WIDTHEF') {
                    controller.model.setWidth(+newValue);
                } else if (fieldName === 'HEIGHTEF') {
                    controller.model.setHeight(+newValue);
                }
            });
        } else if (isNaN(enteredDimension)) {
            cquotedata.clearFieldErrors('WIDTHEF');
            cquotedata.clearFieldErrors('HEIGHTEF');
            cquotedata.clearGlobalErrors();

            cquotedata.addFieldError('WIDTHEF', errorFieldValue);
            cquotedata.addGlobalError('A quote was not completed.  Please make adjustments.');
            var content = '<ul class="validationErrorMessage"><li>A quote was not completed.  Please make adjustments.<li><ul>';
            dynamic.setDivIdContent('validationMessagesDiv', content);

            common.setCQuote(null);
            this.generateDimensionsDiv();

            var configChangeDetails = {
                context: context,
                category: confUtil.FIELD_CHANGE,
                fieldName: fieldName,
                fieldType: 'EF',
                previousValue: null,
                newValue: null
            };
            configureEvents.onQuoteUpdated(configChangeDetails);
        }
    },
    onFocusOperationAnswer: function (fieldName, i) {
        common.efFocus(fieldName, 'operationItemDiv' + i, 'operationFocus' + i);
    },
    onBlurOperationAnswer: function (fieldName, i) {
        var prevAnswer = common.efVals[fieldName];
        var answer = getFormItemValue(fieldName, document);
        var operation = this.model.operations[i];
        var cquotedata = configureglobals.cquotedata;

        dynamic.removeClass('operationItemDiv' + i, 'focus');
        dynamic.setDivIdContent('operationFocus' + i, '');

        if (prevAnswer === answer) {
            return;
        }

        if (operation.itemAnswerIntType) {
            var isEmpty = !answer || !answer.trim().length;
            if (isEmpty || isNaN(answer)) {
                operation.itemAnswerInt = this.model.prepareDefaultAnswers(operation.pjcOperation.id).defaultItemAnswerIntType;
            } else {
                operation.itemAnswerInt = parseInt(answer);
            }
        } else {
            operation.itemAnswer = answer;
        }

        var configChangeDetails = {
            context: 'efBlur',
            category: confUtil.FIELD_CHANGE,
            fieldName: fieldName,
            fieldType: 'EF',
            previousValue: null,
            newValue: operation.itemAnswerIntType ? operation.itemAnswerInt : operation.itemAnswer
        };

        configureEvents.onCalcChanged(configChangeDetails);

        this.updateQuote(configChangeDetails);
    },
    setOperation: function (index, id) {
        var selectedItemId = parseInt(getDropDownSelectedValue('OPERATIONDD' + index, document), 10);

        this.model.setOperationChoice(id, selectedItemId);

        var configChangeDetails = {
            context: 'setOperation',
            category: confUtil.INDEXED_FIELD_CHANGE,
            fieldIndex: index,
            fieldNamePrefix: 'OPERATIONDD',
            fieldID: 'operation' + id,
            fieldType: 'DD',
            previousValue: null,
            newValue: null
        };

        configureEvents.onCalcChanged(configChangeDetails);

        this.updateQuote(configChangeDetails);
    },
    parentController: null,
    onSmallQuoteComplete: function (success) {
        if (this.parentController != null) {
            this.parentController.smallQuoteComplete(success);
        }
        if (typeof shippingCalcWidgetController == 'object') {
            shippingCalcWidgetController.onQuoteChange();
        }
    },
    display: function () {
        controller.generateDeviceChoices();
        controller.generatePressSheetTypeChoices();
        controller.generatePressSheetWeightChoices();
        controller.generatePressSheetColorChoices();
        controller.generateInkChoices();
        controller.generateCoverPressSheetTypeChoices();
        controller.generateCoverPressSheetWeightChoices();
        controller.generateCoverPressSheetColorChoices();
        controller.generateCoverInkChoices();
        controller.generateBleedDiv();
        controller.generateDimensionsDiv();
        controller.generatePagesDiv();
        controller.generateOverrideAmountDiv();
        controller.generatePiecesOnSheetOverrideDiv();
        controller.generateCoverPiecesOnSheetOverrideDiv();
        quantityConfigureController.generateQuantity();
        controller.generateOperationsDiv();
        common.generateProofs();
        common.generateTurnaroundTimes();

        var isRequoteMode = !!configureCommonGlobals.REQUOTE_MODE;
        var isFullQuoteMode = this.mode === controllerMode.FULL_QUOTE;
        if (!isRequoteMode && !isFullQuoteMode) {
            common.generateAdditionalFields();
        }
    },
    fetchProductionTasks: function (request) {
        return new Promise(function (resolve, reject) {
            $.ajax({
                url: '/rest/internal/supplierAdmin/products/productionTasks/custom',
                method: 'POST',
                accept: 'application/json',
                contentType: 'application/json',
                data: request,
                success: function (quoteResponse) {
                    resolve(quoteResponse);
                },
                error: function (errorResponse) {
                    console.error('Error fetching production tasks');
                    reject(errorResponse);
                }
            });
        });
    },
    getProductionTasks: function (quoteRequest) {
        return this.isCustomQuote() ? this.fetchProductionTasks(quoteRequest) : Promise.resolve();
    },
    isCustomQuote: function () {
        return configureCommonGlobals && configureCommonGlobals.SALES_ESTIMATE_MODE === true;
    },
    getQuoteURL: function () {
        if (this.isCustomQuote()) {
            return this.QUOTE_URLS.CUSTOM;
        }

        if (configureCommonGlobals && configureCommonGlobals.REQUOTE_MODE === true) {
            return this.QUOTE_URLS.REQUOTE;
        }

        return USER_TYPE === this.USER_TYPES.SUPPLIER_ADMIN
            ? this.QUOTE_URLS.EXTENDED
            : this.QUOTE_URLS.DEFAULT;
    },
    lastRequestId: 0,
    getQuote: function (isLogin, onQuoteUpdatedFunction, onQuoteUpdateFailedFunction) {
        dynamic.setDivIdContent('jobQuote', '--');

        // Disable "Continue" button until quote successfully generated
        common.setContinueButtonEnabled(false);

        var self = this;
        var requestId = ++this.lastRequestId;

        var quoteRequest = JSON.stringify(this.model.generateQuoteRequestData());

        var quotePromise = tbg.apiV2({
            url: controller.getQuoteURL(),
            urlPrefix: '',
            method: 'POST',
            contentType: 'application/json',
            data: quoteRequest,
            suppressDefaultMessages: true,
            errorHandlers: {
                417: function (response) {
                    if (requestId !== controller.lastRequestId) {
                        return;
                    }
                    common.setCQuoteData(new QuoteDataAdapter(controller.model, response));
                    common.setCQuote(null);
                    controller.onSmallQuoteComplete(null);
                    if (typeof onQuoteUpdatedFunction === 'function') {
                        onQuoteUpdatedFunction();
                    }
                },
                default: function (response) {
                    if (requestId !== controller.lastRequestId) {
                        return;
                    }
                    common.setCQuote(null);
                    controller.onSmallQuoteComplete(null);
                    if (typeof onQuoteUpdateFailedFunction === 'function') {
                        onQuoteUpdateFailedFunction();
                    }
                    configureEvents.onQuoteUpdated(null);
                    var errors = response && response.errors;
                    if (errors && errors.length) {
                        errors.forEach(function (e) {
                            growlMessages.showErrorMessage(e.detail);
                        });
                    } else {
                        growlMessages.showErrorMessage('An error occurred while getting a quote. Please try again.');
                    }
                }
            }
        });

        var productionTasksPromise = this.getProductionTasks(quoteRequest)
            .catch(function () {
                console.error('Error fetching production tasks');
                return null;
            });

        return Promise.all([quotePromise, productionTasksPromise])
            .then(function (responses) {
                var quoteResponse = responses[0];
                var productionTasksResponse = responses[1];

                if (!quoteResponse || requestId !== controller.lastRequestId) {
                    return;
                }

                var quote = quoteResponse.content;
                var productionTasks = productionTasksResponse && productionTasksResponse.content;

                if (productionTasks) {
                    window.tbg.eventHub.trigger(window.tbg.eventHub.events.PRODUCTION_PLAN_SET, [productionTasks]);
                } else {
                    window.tbg.eventHub.trigger(window.tbg.eventHub.events.PRODUCTION_PLAN_SET, [[]]);
                }

                common.setCQuote(USER_TYPE === 'SUPPLIER_ADMIN'
                    ? new ExtendedQuoteAdapter(controller.model, quote)
                    : new QuoteAdapter(controller.model, quote));
                common.setCQuoteData(new QuoteDataAdapter(controller.model, quote));

                common.showValidationMessages(quoteResponse, !self.parentController);

                controller.onSmallQuoteComplete(configureglobals.cquote != null);
                if (common.ef != null) {
                    focusOn(common.ef, document);
                    selectAll(common.ef, document);
                }
                if (typeof onQuoteUpdatedFunction === 'function') {
                    onQuoteUpdatedFunction();
                    common.setContinueButtonEnabled(true);
                }
            });
    },
    updateQuote: function (configChangeDetails) {
        return this.getQuote(false, function () {
            this.generateUI(configChangeDetails, { list: [] });
            configureEvents.onQuoteUpdated(configChangeDetails);
        }.bind(this), function () {
            this.generateUI(configChangeDetails, { list: [] });
        }.bind(this));
    },
    mode: controllerMode.FIELD_CHANGE_QUOTE,
    fieldChangeQuotePending: false,
    getFullQuotePending: false,
    enterFullQuoteMode: function () {
        this.mode = controllerMode.FULL_QUOTE;
        this.getFullQuotePending = false;
        return this.mode;
    },
    exitFullQuoteMode: function (sourceContextConfigChangeDetails) {
        if (this.mode == controllerMode.FIELD_CHANGE_QUOTE) {
            return this.mode;
        }
        this.mode = controllerMode.FIELD_CHANGE_QUOTE;
        if (this.fieldChangeQuotePending && !this.getFullQuotePending) {
            this.getFullQuotePending = true;
            setTimeout(function () {
                controller.updateQuote(sourceContextConfigChangeDetails);
            }, 1);
        }
        return this.mode;
    }
};

$(function () {
    controller.initialize();
});
